//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface INutritionAmbitionApiService {
    /**
     * @return Success
     */
    getAccountInfo(): Observable<AccountInfoResponse>;
    /**
     * @return Success
     */
    cancelSubscription(): Observable<Response>;
    /**
     * @return Success
     */
    deleteAccount(): Observable<Response>;
    /**
     * @return Success
     */
    deleteGuestAccount(): Observable<Response>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerAccount(body: RegisterAccountRequest | undefined): Observable<AccountResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAccount(body: Request | undefined): Observable<AccountResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordRequest | undefined): Observable<Response>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getUnacknowledgedFeedback(body: Request | undefined): Observable<GetFeedbackResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    markFeedbackAsShown(body: MarkFeedbackAsShownRequest | undefined): Observable<Response>;
    /**
     * @return Success
     */
    dismissAppDownloadBanner(): Observable<Response>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFeedbackWithAccountInfo(body: GetFeedbackWithAccountInfoRequest | undefined): Observable<GetFeedbackWithAccountInfoResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    completeFeedback(body: CompleteFeedbackRequest | undefined): Observable<CompleteFeedbackResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteFeedback(body: DeleteFeedbackRequest | undefined): Observable<DeleteFeedbackResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getUserChatMessages(body: GetUserChatMessagesRequest | undefined): Observable<GetUserChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchLogs(body: SearchLogsRequest | undefined): Observable<SearchLogsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAccounts(body: GetAllAccountsRequest | undefined): Observable<GetAllAccountsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteAccount2(body: DeleteAccountRequest | undefined): Observable<DeleteAccountResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    clearAccountData(body: ClearAccountDataRequest | undefined): Observable<ClearAccountDataResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountDataCounts(body: GetAccountDataCountsRequest | undefined): Observable<GetAccountDataCountsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    uploadGuidelineFile(body: UploadGuidelineFileRequest | undefined): Observable<UploadGuidelineFileResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getGuidelineFiles(body: GetGuidelineFilesRequest | undefined): Observable<GetGuidelineFilesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteGuidelineFile(body: DeleteGuidelineFileRequest | undefined): Observable<DeleteGuidelineFileResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getGuidelineFileUploadUrl(body: GetGuidelineFileUploadUrlRequest | undefined): Observable<GetGuidelineFileUploadUrlResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    confirmGuidelineFileUpload(body: ConfirmGuidelineFileUploadRequest | undefined): Observable<ConfirmGuidelineFileUploadResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getGuidelineFileViewUrl(body: GetGuidelineFileViewUrlRequest | undefined): Observable<GetGuidelineFileViewUrlResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    adjustAccountDates(body: AdjustAccountDatesRequest | undefined): Observable<AdjustAccountDatesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setTrialEndDate(body: SetTrialEndDateRequest | undefined): Observable<SetTrialEndDateResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    checkFcmToken(body: CheckFcmTokenRequest | undefined): Observable<CheckFcmTokenResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sendNotification(body: SendNotificationRequest | undefined): Observable<SendNotificationResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getNotifiableAccounts(body: GetNotifiableAccountsRequest | undefined): Observable<GetNotifiableAccountsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sendBulkNotification(body: SendBulkNotificationRequest | undefined): Observable<SendBulkNotificationResponse>;
    /**
     * @param redirectPath (optional) 
     * @return Success
     */
    createAuthHandoffToken(redirectPath: string | undefined): Observable<CreateAuthHandoffTokenResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    validateHandoff(body: ValidateHandoffRequest | undefined): Observable<ValidateHandoffResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getChatMessages(body: GetChatMessagesRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    types(body: RunChatRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    runResponsesConversation(body: RunChatRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    types2(body: SetupGoalsRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setupGoals(body: SetupGoalsRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    types3(body: SetupPreferencesRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setupPreferences(body: SetupPreferencesRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    types4(body: SetupNotificationsRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setupNotifications(body: SetupNotificationsRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    types5(body: LearnMoreAboutRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    learnMoreAbout(body: LearnMoreAboutRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    types6(body: TriggerConversationContinuationRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    triggerConversationContinuation(body: TriggerConversationContinuationRequest | undefined): Observable<void>;
    /**
     * @return Success
     */
    deleteMessage(messageId: string): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    types7(body: TriggerActionRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    triggerAction(body: TriggerActionRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    showRestrictedMessage(body: ShowRestrictedMessageRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    showLoggingExample(body: ShowLoggingExampleRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getDetailedSummary(body: GetDetailedSummaryRequest | undefined): Observable<GetDetailedSummaryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFavorites(body: GetFavoritesRequest | undefined): Observable<GetFavoritesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    relogFavorite(body: RelogFavoriteRequest | undefined): Observable<RelogFavoriteResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeFavorite(body: RemoveFavoriteRequest | undefined): Observable<RemoveFavoriteResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteFoodEntry(body: DeleteFoodEntryRequest | undefined): Observable<DeleteFoodEntryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    submitServingSelection(body: SubmitServingSelectionRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    cancelFoodLogging(body: CancelServingSelectionRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    startEditSelection(body: EditFoodSelectionRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    submitEditServingSelection(body: SubmitEditServingSelectionRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    cancelEditSelection(body: CancelEditSelectionRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateFoodPhrase(body: SearchFoodPhraseRequest | undefined): Observable<SearchFoodPhraseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    hydrateAlternateSelection(body: HydrateAlternateSelectionRequest | undefined): Observable<SearchFoodPhraseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchFoodPhrase(body: SearchFoodPhraseRequest | undefined): Observable<SearchFoodPhraseResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchBarcode(body: BarcodeSearchRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getInstantAlternatives(body: GetInstantAlternativesRequest | undefined): Observable<GetInstantAlternativesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateMealSelection(body: UpdateMealSelectionRequest | undefined): Observable<Response>;
    /**
     * @param body (optional) 
     * @return Success
     */
    directLogMealStream(body: DirectLogMealRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    activeFoodLogStream(body: ActiveFoodLogRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    photoSearchStream(body: PhotoSearchRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    configureAppleOutbound(body: ConfigureAppleOutboundRequest | undefined): Observable<OutboundConnectionResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    configureHealthConnectInbound(body: ConfigureHealthConnectInboundRequest | undefined): Observable<InboundConnectionResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    disconnect(body: DisconnectHealthConnectionRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    appleOutboundFeed(body: AppleOutboundFeedRequest | undefined): Observable<AppleOutboundFeedResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    uploadDailyEnergyBatch(body: UploadDailyEnergyBatchRequest | undefined): Observable<HealthHistoryProgressResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    historyRun(body: HealthHistoryRunRequest | undefined): Observable<HealthHistoryProgressResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    cancelHistoryRun(body: HealthHistoryRunRequest | undefined): Observable<HealthHistoryProgressResponse>;
    /**
     * @return Success
     */
    deleteImportedHistory(): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeSharedMeals(body: HealthHistoryRunRequest | undefined): Observable<RemoveSharedMealsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    acknowledgeAppleOutbound(body: AppleOutboundAck | undefined): Observable<void>;
    /**
     * @return Success
     */
    run(): Observable<RunScheduledNotificationsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSession(body: CreateCheckoutSessionRequest | undefined): Observable<CreateCheckoutSessionResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getProfileAndTargets(body: GetProfileAndTargetsRequest | undefined): Observable<GetProfileAndTargetsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerDevice(body: RegisterDeviceRequest | undefined): Observable<Response>;
    /**
     * @param body (optional) 
     * @return Success
     */
    types8(body: NotificationActionRequest | undefined): Observable<ChatMessagesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    notificationAction(body: NotificationActionRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createSharedMeal(body: CreateSharedMealRequest | undefined): Observable<CreateSharedMealResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getSharedMeal(body: GetSharedMealRequest | undefined): Observable<GetSharedMealResponse>;
    /**
     * @return Success
     */
    stripe(): Observable<void>;
    /**
     * @return Success
     */
    ip(): Observable<void>;
}

@Injectable()
export class NutritionAmbitionApiService implements INutritionAmbitionApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAccountInfo(): Observable<AccountInfoResponse> {
        let url_ = this.baseUrl + "/api/AccountManagement/GetAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountInfoResponse>;
        }));
    }

    protected processGetAccountInfo(response: HttpResponseBase): Observable<AccountInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountInfoResponse>(null as any);
    }

    /**
     * @return Success
     */
    cancelSubscription(): Observable<Response> {
        let url_ = this.baseUrl + "/api/AccountManagement/CancelSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processCancelSubscription(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(null as any);
    }

    /**
     * @return Success
     */
    deleteAccount(): Observable<Response> {
        let url_ = this.baseUrl + "/api/AccountManagement/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processDeleteAccount(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(null as any);
    }

    /**
     * @return Success
     */
    deleteGuestAccount(): Observable<Response> {
        let url_ = this.baseUrl + "/api/AccountManagement/DeleteGuestAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGuestAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGuestAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processDeleteGuestAccount(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerAccount(body: RegisterAccountRequest | undefined): Observable<AccountResponse> {
        let url_ = this.baseUrl + "/api/Accounts/RegisterAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountResponse>;
        }));
    }

    protected processRegisterAccount(response: HttpResponseBase): Observable<AccountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAccount(body: Request | undefined): Observable<AccountResponse> {
        let url_ = this.baseUrl + "/api/Accounts/GetAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountResponse>;
        }));
    }

    protected processGetAccount(response: HttpResponseBase): Observable<AccountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordRequest | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/api/Accounts/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUnacknowledgedFeedback(body: Request | undefined): Observable<GetFeedbackResponse> {
        let url_ = this.baseUrl + "/api/Accounts/GetUnacknowledgedFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnacknowledgedFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnacknowledgedFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFeedbackResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFeedbackResponse>;
        }));
    }

    protected processGetUnacknowledgedFeedback(response: HttpResponseBase): Observable<GetFeedbackResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFeedbackResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFeedbackResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markFeedbackAsShown(body: MarkFeedbackAsShownRequest | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/api/Accounts/MarkFeedbackAsShown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkFeedbackAsShown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkFeedbackAsShown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processMarkFeedbackAsShown(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(null as any);
    }

    /**
     * @return Success
     */
    dismissAppDownloadBanner(): Observable<Response> {
        let url_ = this.baseUrl + "/api/Accounts/DismissAppDownloadBanner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismissAppDownloadBanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismissAppDownloadBanner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processDismissAppDownloadBanner(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFeedbackWithAccountInfo(body: GetFeedbackWithAccountInfoRequest | undefined): Observable<GetFeedbackWithAccountInfoResponse> {
        let url_ = this.baseUrl + "/api/Admin/GetFeedbackWithAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeedbackWithAccountInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeedbackWithAccountInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFeedbackWithAccountInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFeedbackWithAccountInfoResponse>;
        }));
    }

    protected processGetFeedbackWithAccountInfo(response: HttpResponseBase): Observable<GetFeedbackWithAccountInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFeedbackWithAccountInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFeedbackWithAccountInfoResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeFeedback(body: CompleteFeedbackRequest | undefined): Observable<CompleteFeedbackResponse> {
        let url_ = this.baseUrl + "/api/Admin/CompleteFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompleteFeedbackResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompleteFeedbackResponse>;
        }));
    }

    protected processCompleteFeedback(response: HttpResponseBase): Observable<CompleteFeedbackResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompleteFeedbackResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompleteFeedbackResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteFeedback(body: DeleteFeedbackRequest | undefined): Observable<DeleteFeedbackResponse> {
        let url_ = this.baseUrl + "/api/Admin/DeleteFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteFeedbackResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteFeedbackResponse>;
        }));
    }

    protected processDeleteFeedback(response: HttpResponseBase): Observable<DeleteFeedbackResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFeedbackResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteFeedbackResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserChatMessages(body: GetUserChatMessagesRequest | undefined): Observable<GetUserChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Admin/GetUserChatMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserChatMessagesResponse>;
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<GetUserChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchLogs(body: SearchLogsRequest | undefined): Observable<SearchLogsResponse> {
        let url_ = this.baseUrl + "/api/Admin/SearchLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchLogsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchLogsResponse>;
        }));
    }

    protected processSearchLogs(response: HttpResponseBase): Observable<SearchLogsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchLogsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchLogsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAccounts(body: GetAllAccountsRequest | undefined): Observable<GetAllAccountsResponse> {
        let url_ = this.baseUrl + "/api/Admin/GetAllAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllAccountsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllAccountsResponse>;
        }));
    }

    protected processGetAllAccounts(response: HttpResponseBase): Observable<GetAllAccountsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllAccountsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllAccountsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteAccount2(body: DeleteAccountRequest | undefined): Observable<DeleteAccountResponse> {
        let url_ = this.baseUrl + "/api/Admin/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccount2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccount2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteAccountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteAccountResponse>;
        }));
    }

    protected processDeleteAccount2(response: HttpResponseBase): Observable<DeleteAccountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteAccountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteAccountResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearAccountData(body: ClearAccountDataRequest | undefined): Observable<ClearAccountDataResponse> {
        let url_ = this.baseUrl + "/api/Admin/ClearAccountData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAccountData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAccountData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClearAccountDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClearAccountDataResponse>;
        }));
    }

    protected processClearAccountData(response: HttpResponseBase): Observable<ClearAccountDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClearAccountDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClearAccountDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountDataCounts(body: GetAccountDataCountsRequest | undefined): Observable<GetAccountDataCountsResponse> {
        let url_ = this.baseUrl + "/api/Admin/GetAccountDataCounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountDataCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountDataCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAccountDataCountsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAccountDataCountsResponse>;
        }));
    }

    protected processGetAccountDataCounts(response: HttpResponseBase): Observable<GetAccountDataCountsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountDataCountsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAccountDataCountsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadGuidelineFile(body: UploadGuidelineFileRequest | undefined): Observable<UploadGuidelineFileResponse> {
        let url_ = this.baseUrl + "/api/Admin/UploadGuidelineFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadGuidelineFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadGuidelineFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadGuidelineFileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadGuidelineFileResponse>;
        }));
    }

    protected processUploadGuidelineFile(response: HttpResponseBase): Observable<UploadGuidelineFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadGuidelineFileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadGuidelineFileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getGuidelineFiles(body: GetGuidelineFilesRequest | undefined): Observable<GetGuidelineFilesResponse> {
        let url_ = this.baseUrl + "/api/Admin/GetGuidelineFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuidelineFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuidelineFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGuidelineFilesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGuidelineFilesResponse>;
        }));
    }

    protected processGetGuidelineFiles(response: HttpResponseBase): Observable<GetGuidelineFilesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGuidelineFilesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGuidelineFilesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteGuidelineFile(body: DeleteGuidelineFileRequest | undefined): Observable<DeleteGuidelineFileResponse> {
        let url_ = this.baseUrl + "/api/Admin/DeleteGuidelineFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGuidelineFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGuidelineFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteGuidelineFileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteGuidelineFileResponse>;
        }));
    }

    protected processDeleteGuidelineFile(response: HttpResponseBase): Observable<DeleteGuidelineFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGuidelineFileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteGuidelineFileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getGuidelineFileUploadUrl(body: GetGuidelineFileUploadUrlRequest | undefined): Observable<GetGuidelineFileUploadUrlResponse> {
        let url_ = this.baseUrl + "/api/Admin/GetGuidelineFileUploadUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuidelineFileUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuidelineFileUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGuidelineFileUploadUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGuidelineFileUploadUrlResponse>;
        }));
    }

    protected processGetGuidelineFileUploadUrl(response: HttpResponseBase): Observable<GetGuidelineFileUploadUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGuidelineFileUploadUrlResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGuidelineFileUploadUrlResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmGuidelineFileUpload(body: ConfirmGuidelineFileUploadRequest | undefined): Observable<ConfirmGuidelineFileUploadResponse> {
        let url_ = this.baseUrl + "/api/Admin/ConfirmGuidelineFileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmGuidelineFileUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmGuidelineFileUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfirmGuidelineFileUploadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfirmGuidelineFileUploadResponse>;
        }));
    }

    protected processConfirmGuidelineFileUpload(response: HttpResponseBase): Observable<ConfirmGuidelineFileUploadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmGuidelineFileUploadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfirmGuidelineFileUploadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getGuidelineFileViewUrl(body: GetGuidelineFileViewUrlRequest | undefined): Observable<GetGuidelineFileViewUrlResponse> {
        let url_ = this.baseUrl + "/api/Admin/GetGuidelineFileViewUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuidelineFileViewUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuidelineFileViewUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGuidelineFileViewUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGuidelineFileViewUrlResponse>;
        }));
    }

    protected processGetGuidelineFileViewUrl(response: HttpResponseBase): Observable<GetGuidelineFileViewUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGuidelineFileViewUrlResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGuidelineFileViewUrlResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    adjustAccountDates(body: AdjustAccountDatesRequest | undefined): Observable<AdjustAccountDatesResponse> {
        let url_ = this.baseUrl + "/api/Admin/AdjustAccountDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustAccountDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustAccountDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustAccountDatesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustAccountDatesResponse>;
        }));
    }

    protected processAdjustAccountDates(response: HttpResponseBase): Observable<AdjustAccountDatesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdjustAccountDatesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdjustAccountDatesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setTrialEndDate(body: SetTrialEndDateRequest | undefined): Observable<SetTrialEndDateResponse> {
        let url_ = this.baseUrl + "/api/Admin/SetTrialEndDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTrialEndDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTrialEndDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetTrialEndDateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetTrialEndDateResponse>;
        }));
    }

    protected processSetTrialEndDate(response: HttpResponseBase): Observable<SetTrialEndDateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetTrialEndDateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetTrialEndDateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkFcmToken(body: CheckFcmTokenRequest | undefined): Observable<CheckFcmTokenResponse> {
        let url_ = this.baseUrl + "/api/Admin/CheckFcmToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckFcmToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckFcmToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckFcmTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckFcmTokenResponse>;
        }));
    }

    protected processCheckFcmToken(response: HttpResponseBase): Observable<CheckFcmTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckFcmTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckFcmTokenResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendNotification(body: SendNotificationRequest | undefined): Observable<SendNotificationResponse> {
        let url_ = this.baseUrl + "/api/Admin/SendNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendNotificationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendNotificationResponse>;
        }));
    }

    protected processSendNotification(response: HttpResponseBase): Observable<SendNotificationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendNotificationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendNotificationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getNotifiableAccounts(body: GetNotifiableAccountsRequest | undefined): Observable<GetNotifiableAccountsResponse> {
        let url_ = this.baseUrl + "/api/Admin/GetNotifiableAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifiableAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifiableAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotifiableAccountsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotifiableAccountsResponse>;
        }));
    }

    protected processGetNotifiableAccounts(response: HttpResponseBase): Observable<GetNotifiableAccountsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotifiableAccountsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotifiableAccountsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendBulkNotification(body: SendBulkNotificationRequest | undefined): Observable<SendBulkNotificationResponse> {
        let url_ = this.baseUrl + "/api/Admin/SendBulkNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendBulkNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendBulkNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendBulkNotificationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendBulkNotificationResponse>;
        }));
    }

    protected processSendBulkNotification(response: HttpResponseBase): Observable<SendBulkNotificationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendBulkNotificationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendBulkNotificationResponse>(null as any);
    }

    /**
     * @param redirectPath (optional) 
     * @return Success
     */
    createAuthHandoffToken(redirectPath: string | undefined): Observable<CreateAuthHandoffTokenResponse> {
        let url_ = this.baseUrl + "/api/Auth/CreateAuthHandoffToken?";
        if (redirectPath === null)
            throw new Error("The parameter 'redirectPath' cannot be null.");
        else if (redirectPath !== undefined)
            url_ += "redirectPath=" + encodeURIComponent("" + redirectPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAuthHandoffToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAuthHandoffToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAuthHandoffTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAuthHandoffTokenResponse>;
        }));
    }

    protected processCreateAuthHandoffToken(response: HttpResponseBase): Observable<CreateAuthHandoffTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAuthHandoffTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateAuthHandoffTokenResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateHandoff(body: ValidateHandoffRequest | undefined): Observable<ValidateHandoffResponse> {
        let url_ = this.baseUrl + "/api/Auth/ValidateHandoff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateHandoff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateHandoff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateHandoffResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateHandoffResponse>;
        }));
    }

    protected processValidateHandoff(response: HttpResponseBase): Observable<ValidateHandoffResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateHandoffResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateHandoffResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getChatMessages(body: GetChatMessagesRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Conversation/GetChatMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processGetChatMessages(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    types(body: RunChatRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Conversation/RunResponsesConversation/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processTypes(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    runResponsesConversation(body: RunChatRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Conversation/RunResponsesConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunResponsesConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunResponsesConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunResponsesConversation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    types2(body: SetupGoalsRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Conversation/SetupGoals/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processTypes2(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setupGoals(body: SetupGoalsRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Conversation/SetupGoals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetupGoals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetupGoals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetupGoals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    types3(body: SetupPreferencesRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Conversation/SetupPreferences/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processTypes3(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setupPreferences(body: SetupPreferencesRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Conversation/SetupPreferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetupPreferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetupPreferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetupPreferences(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    types4(body: SetupNotificationsRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Conversation/SetupNotifications/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processTypes4(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setupNotifications(body: SetupNotificationsRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Conversation/SetupNotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetupNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetupNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetupNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    types5(body: LearnMoreAboutRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Conversation/LearnMoreAbout/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processTypes5(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    learnMoreAbout(body: LearnMoreAboutRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Conversation/LearnMoreAbout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLearnMoreAbout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLearnMoreAbout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLearnMoreAbout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    types6(body: TriggerConversationContinuationRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Conversation/TriggerConversationContinuation/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processTypes6(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    triggerConversationContinuation(body: TriggerConversationContinuationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Conversation/TriggerConversationContinuation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerConversationContinuation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerConversationContinuation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTriggerConversationContinuation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteMessage(messageId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Conversation/DeleteMessage/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    types7(body: TriggerActionRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Conversation/TriggerAction/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processTypes7(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    triggerAction(body: TriggerActionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Conversation/TriggerAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTriggerAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    showRestrictedMessage(body: ShowRestrictedMessageRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Conversation/ShowRestrictedMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShowRestrictedMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShowRestrictedMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processShowRestrictedMessage(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    showLoggingExample(body: ShowLoggingExampleRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/Conversation/ShowLoggingExample";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShowLoggingExample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShowLoggingExample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processShowLoggingExample(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDetailedSummary(body: GetDetailedSummaryRequest | undefined): Observable<GetDetailedSummaryResponse> {
        let url_ = this.baseUrl + "/api/DetailedSummary/GetDetailedSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDetailedSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDetailedSummaryResponse>;
        }));
    }

    protected processGetDetailedSummary(response: HttpResponseBase): Observable<GetDetailedSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDetailedSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDetailedSummaryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFavorites(body: GetFavoritesRequest | undefined): Observable<GetFavoritesResponse> {
        let url_ = this.baseUrl + "/api/Favorites/GetFavorites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFavorites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFavorites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFavoritesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFavoritesResponse>;
        }));
    }

    protected processGetFavorites(response: HttpResponseBase): Observable<GetFavoritesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFavoritesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFavoritesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    relogFavorite(body: RelogFavoriteRequest | undefined): Observable<RelogFavoriteResponse> {
        let url_ = this.baseUrl + "/api/Favorites/RelogFavorite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelogFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelogFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelogFavoriteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelogFavoriteResponse>;
        }));
    }

    protected processRelogFavorite(response: HttpResponseBase): Observable<RelogFavoriteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelogFavoriteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RelogFavoriteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeFavorite(body: RemoveFavoriteRequest | undefined): Observable<RemoveFavoriteResponse> {
        let url_ = this.baseUrl + "/api/Favorites/RemoveFavorite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveFavoriteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveFavoriteResponse>;
        }));
    }

    protected processRemoveFavorite(response: HttpResponseBase): Observable<RemoveFavoriteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoveFavoriteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoveFavoriteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteFoodEntry(body: DeleteFoodEntryRequest | undefined): Observable<DeleteFoodEntryResponse> {
        let url_ = this.baseUrl + "/api/FoodEntry/DeleteFoodEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFoodEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFoodEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteFoodEntryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteFoodEntryResponse>;
        }));
    }

    protected processDeleteFoodEntry(response: HttpResponseBase): Observable<DeleteFoodEntryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFoodEntryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteFoodEntryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitServingSelection(body: SubmitServingSelectionRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/FoodSelection/SubmitServingSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitServingSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitServingSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processSubmitServingSelection(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelFoodLogging(body: CancelServingSelectionRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/FoodSelection/CancelFoodLogging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelFoodLogging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelFoodLogging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processCancelFoodLogging(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startEditSelection(body: EditFoodSelectionRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/FoodSelection/StartEditSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartEditSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartEditSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processStartEditSelection(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitEditServingSelection(body: SubmitEditServingSelectionRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/FoodSelection/SubmitEditServingSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitEditServingSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitEditServingSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processSubmitEditServingSelection(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelEditSelection(body: CancelEditSelectionRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/FoodSelection/CancelEditSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelEditSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelEditSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processCancelEditSelection(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFoodPhrase(body: SearchFoodPhraseRequest | undefined): Observable<SearchFoodPhraseResponse> {
        let url_ = this.baseUrl + "/api/FoodSelection/UpdateFoodPhrase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFoodPhrase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFoodPhrase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFoodPhraseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFoodPhraseResponse>;
        }));
    }

    protected processUpdateFoodPhrase(response: HttpResponseBase): Observable<SearchFoodPhraseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchFoodPhraseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFoodPhraseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    hydrateAlternateSelection(body: HydrateAlternateSelectionRequest | undefined): Observable<SearchFoodPhraseResponse> {
        let url_ = this.baseUrl + "/api/FoodSelection/HydrateAlternateSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHydrateAlternateSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHydrateAlternateSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFoodPhraseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFoodPhraseResponse>;
        }));
    }

    protected processHydrateAlternateSelection(response: HttpResponseBase): Observable<SearchFoodPhraseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchFoodPhraseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFoodPhraseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchFoodPhrase(body: SearchFoodPhraseRequest | undefined): Observable<SearchFoodPhraseResponse> {
        let url_ = this.baseUrl + "/api/FoodSelection/SearchFoodPhrase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFoodPhrase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFoodPhrase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFoodPhraseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFoodPhraseResponse>;
        }));
    }

    protected processSearchFoodPhrase(response: HttpResponseBase): Observable<SearchFoodPhraseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchFoodPhraseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFoodPhraseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchBarcode(body: BarcodeSearchRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FoodSelection/SearchBarcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBarcode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSearchBarcode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getInstantAlternatives(body: GetInstantAlternativesRequest | undefined): Observable<GetInstantAlternativesResponse> {
        let url_ = this.baseUrl + "/api/FoodSelection/GetInstantAlternatives";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstantAlternatives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstantAlternatives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInstantAlternativesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInstantAlternativesResponse>;
        }));
    }

    protected processGetInstantAlternatives(response: HttpResponseBase): Observable<GetInstantAlternativesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInstantAlternativesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetInstantAlternativesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMealSelection(body: UpdateMealSelectionRequest | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/api/FoodSelection/UpdateMealSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMealSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMealSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processUpdateMealSelection(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    directLogMealStream(body: DirectLogMealRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FoodSelection/DirectLogMealStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDirectLogMealStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDirectLogMealStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDirectLogMealStream(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activeFoodLogStream(body: ActiveFoodLogRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FoodSelection/ActiveFoodLogStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveFoodLogStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveFoodLogStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActiveFoodLogStream(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    photoSearchStream(body: PhotoSearchRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FoodSelection/PhotoSearchStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhotoSearchStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhotoSearchStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPhotoSearchStream(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    configureAppleOutbound(body: ConfigureAppleOutboundRequest | undefined): Observable<OutboundConnectionResponse> {
        let url_ = this.baseUrl + "/api/HealthSync/ConfigureAppleOutbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigureAppleOutbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigureAppleOutbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutboundConnectionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutboundConnectionResponse>;
        }));
    }

    protected processConfigureAppleOutbound(response: HttpResponseBase): Observable<OutboundConnectionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutboundConnectionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutboundConnectionResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    configureHealthConnectInbound(body: ConfigureHealthConnectInboundRequest | undefined): Observable<InboundConnectionResponse> {
        let url_ = this.baseUrl + "/api/HealthSync/ConfigureHealthConnectInbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigureHealthConnectInbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigureHealthConnectInbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InboundConnectionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InboundConnectionResponse>;
        }));
    }

    protected processConfigureHealthConnectInbound(response: HttpResponseBase): Observable<InboundConnectionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InboundConnectionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InboundConnectionResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disconnect(body: DisconnectHealthConnectionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/HealthSync/Disconnect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisconnect(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    appleOutboundFeed(body: AppleOutboundFeedRequest | undefined): Observable<AppleOutboundFeedResponse> {
        let url_ = this.baseUrl + "/api/HealthSync/AppleOutboundFeed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppleOutboundFeed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppleOutboundFeed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppleOutboundFeedResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppleOutboundFeedResponse>;
        }));
    }

    protected processAppleOutboundFeed(response: HttpResponseBase): Observable<AppleOutboundFeedResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppleOutboundFeedResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppleOutboundFeedResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadDailyEnergyBatch(body: UploadDailyEnergyBatchRequest | undefined): Observable<HealthHistoryProgressResponse> {
        let url_ = this.baseUrl + "/api/HealthSync/UploadDailyEnergyBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDailyEnergyBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDailyEnergyBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthHistoryProgressResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthHistoryProgressResponse>;
        }));
    }

    protected processUploadDailyEnergyBatch(response: HttpResponseBase): Observable<HealthHistoryProgressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthHistoryProgressResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthHistoryProgressResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    historyRun(body: HealthHistoryRunRequest | undefined): Observable<HealthHistoryProgressResponse> {
        let url_ = this.baseUrl + "/api/HealthSync/HistoryRun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistoryRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistoryRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthHistoryProgressResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthHistoryProgressResponse>;
        }));
    }

    protected processHistoryRun(response: HttpResponseBase): Observable<HealthHistoryProgressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthHistoryProgressResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthHistoryProgressResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelHistoryRun(body: HealthHistoryRunRequest | undefined): Observable<HealthHistoryProgressResponse> {
        let url_ = this.baseUrl + "/api/HealthSync/CancelHistoryRun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelHistoryRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelHistoryRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthHistoryProgressResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthHistoryProgressResponse>;
        }));
    }

    protected processCancelHistoryRun(response: HttpResponseBase): Observable<HealthHistoryProgressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthHistoryProgressResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthHistoryProgressResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteImportedHistory(): Observable<void> {
        let url_ = this.baseUrl + "/api/HealthSync/DeleteImportedHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImportedHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImportedHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteImportedHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeSharedMeals(body: HealthHistoryRunRequest | undefined): Observable<RemoveSharedMealsResponse> {
        let url_ = this.baseUrl + "/api/HealthSync/RemoveSharedMeals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSharedMeals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSharedMeals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveSharedMealsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveSharedMealsResponse>;
        }));
    }

    protected processRemoveSharedMeals(response: HttpResponseBase): Observable<RemoveSharedMealsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoveSharedMealsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoveSharedMealsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acknowledgeAppleOutbound(body: AppleOutboundAck | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/HealthSync/AcknowledgeAppleOutbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgeAppleOutbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgeAppleOutbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcknowledgeAppleOutbound(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    run(): Observable<RunScheduledNotificationsResponse> {
        let url_ = this.baseUrl + "/internal/jobs/notifications/run";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RunScheduledNotificationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RunScheduledNotificationsResponse>;
        }));
    }

    protected processRun(response: HttpResponseBase): Observable<RunScheduledNotificationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RunScheduledNotificationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RunScheduledNotificationsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSession(body: CreateCheckoutSessionRequest | undefined): Observable<CreateCheckoutSessionResponse> {
        let url_ = this.baseUrl + "/api/Payments/CreateCheckoutSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCheckoutSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCheckoutSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCheckoutSessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCheckoutSessionResponse>;
        }));
    }

    protected processCreateCheckoutSession(response: HttpResponseBase): Observable<CreateCheckoutSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCheckoutSessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateCheckoutSessionResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProfileAndTargets(body: GetProfileAndTargetsRequest | undefined): Observable<GetProfileAndTargetsResponse> {
        let url_ = this.baseUrl + "/api/Profile/GetProfileAndTargets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileAndTargets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileAndTargets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfileAndTargetsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfileAndTargetsResponse>;
        }));
    }

    protected processGetProfileAndTargets(response: HttpResponseBase): Observable<GetProfileAndTargetsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfileAndTargetsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfileAndTargetsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerDevice(body: RegisterDeviceRequest | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/api/PushNotification/RegisterDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processRegisterDevice(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    types8(body: NotificationActionRequest | undefined): Observable<ChatMessagesResponse> {
        let url_ = this.baseUrl + "/api/PushNotification/notificationAction/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes8(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessagesResponse>;
        }));
    }

    protected processTypes8(response: HttpResponseBase): Observable<ChatMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notificationAction(body: NotificationActionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PushNotification/notificationAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotificationAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSharedMeal(body: CreateSharedMealRequest | undefined): Observable<CreateSharedMealResponse> {
        let url_ = this.baseUrl + "/api/SharedMeal/CreateSharedMeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSharedMeal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSharedMeal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSharedMealResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSharedMealResponse>;
        }));
    }

    protected processCreateSharedMeal(response: HttpResponseBase): Observable<CreateSharedMealResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSharedMealResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSharedMealResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSharedMeal(body: GetSharedMealRequest | undefined): Observable<GetSharedMealResponse> {
        let url_ = this.baseUrl + "/api/SharedMeal/GetSharedMeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSharedMeal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSharedMeal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSharedMealResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSharedMealResponse>;
        }));
    }

    protected processGetSharedMeal(response: HttpResponseBase): Observable<GetSharedMealResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSharedMealResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSharedMealResponse>(null as any);
    }

    /**
     * @return Success
     */
    stripe(): Observable<void> {
        let url_ = this.baseUrl + "/api/webhooks/stripe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStripe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStripe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStripe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    ip(): Observable<void> {
        let url_ = this.baseUrl + "/api/Test/ip";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class Account implements IAccount {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    name?: string | undefined;
    email?: string | undefined;
    timeZoneId?: string | undefined;
    clientPlatform?: string | undefined;
    isOwner?: boolean;
    isEarlyAccess?: boolean;
    hasUnacknowledgedAssistantResponses?: boolean;
    canDelete?: boolean;
    canClear?: boolean;
    automaticNotificationsEnabled?: boolean;
    trialEndDateUtc?: Date | undefined;
    isPremium?: boolean;
    isPremiumLifetime?: boolean;
    subscriptionStatus?: SubscriptionStatus;
    stripeCustomerId?: string | undefined;
    stripeSubscriptionId?: string | undefined;
    subscriptionPriceId?: string | undefined;
    subscriptionCurrentPeriodEndUtc?: Date | undefined;
    accountDeletedDateUtc?: Date | undefined;
    continuationMessageId?: string | undefined;
    isRestrictedAccess?: boolean;
    restrictedAccessPhase?: string | undefined;
    assistantPreferences?: CommunicationPreferences;
    nutritionixRemoteUserId?: string | undefined;
    marketingEmailsOptIn?: boolean;
    referrer?: string | undefined;
    referrerId?: string | undefined;
    onboardingProgress?: OnboardingProgress;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.lastUpdatedDateUtc = _data["lastUpdatedDateUtc"] ? new Date(_data["lastUpdatedDateUtc"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.email = _data["email"];
            this.timeZoneId = _data["timeZoneId"];
            this.clientPlatform = _data["clientPlatform"];
            this.isOwner = _data["isOwner"];
            this.isEarlyAccess = _data["isEarlyAccess"];
            this.hasUnacknowledgedAssistantResponses = _data["hasUnacknowledgedAssistantResponses"];
            this.canDelete = _data["canDelete"];
            this.canClear = _data["canClear"];
            this.automaticNotificationsEnabled = _data["automaticNotificationsEnabled"];
            this.trialEndDateUtc = _data["trialEndDateUtc"] ? new Date(_data["trialEndDateUtc"].toString()) : <any>undefined;
            this.isPremium = _data["isPremium"];
            this.isPremiumLifetime = _data["isPremiumLifetime"];
            this.subscriptionStatus = _data["subscriptionStatus"];
            this.stripeCustomerId = _data["stripeCustomerId"];
            this.stripeSubscriptionId = _data["stripeSubscriptionId"];
            this.subscriptionPriceId = _data["subscriptionPriceId"];
            this.subscriptionCurrentPeriodEndUtc = _data["subscriptionCurrentPeriodEndUtc"] ? new Date(_data["subscriptionCurrentPeriodEndUtc"].toString()) : <any>undefined;
            this.accountDeletedDateUtc = _data["accountDeletedDateUtc"] ? new Date(_data["accountDeletedDateUtc"].toString()) : <any>undefined;
            this.continuationMessageId = _data["continuationMessageId"];
            this.isRestrictedAccess = _data["isRestrictedAccess"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.assistantPreferences = _data["assistantPreferences"] ? CommunicationPreferences.fromJS(_data["assistantPreferences"]) : <any>undefined;
            this.nutritionixRemoteUserId = _data["nutritionixRemoteUserId"];
            this.marketingEmailsOptIn = _data["marketingEmailsOptIn"];
            this.referrer = _data["referrer"];
            this.referrerId = _data["referrerId"];
            this.onboardingProgress = _data["onboardingProgress"] ? OnboardingProgress.fromJS(_data["onboardingProgress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["lastUpdatedDateUtc"] = this.lastUpdatedDateUtc ? this.lastUpdatedDateUtc.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["email"] = this.email;
        data["timeZoneId"] = this.timeZoneId;
        data["clientPlatform"] = this.clientPlatform;
        data["isOwner"] = this.isOwner;
        data["isEarlyAccess"] = this.isEarlyAccess;
        data["hasUnacknowledgedAssistantResponses"] = this.hasUnacknowledgedAssistantResponses;
        data["canDelete"] = this.canDelete;
        data["canClear"] = this.canClear;
        data["automaticNotificationsEnabled"] = this.automaticNotificationsEnabled;
        data["trialEndDateUtc"] = this.trialEndDateUtc ? this.trialEndDateUtc.toISOString() : <any>undefined;
        data["isPremium"] = this.isPremium;
        data["isPremiumLifetime"] = this.isPremiumLifetime;
        data["subscriptionStatus"] = this.subscriptionStatus;
        data["stripeCustomerId"] = this.stripeCustomerId;
        data["stripeSubscriptionId"] = this.stripeSubscriptionId;
        data["subscriptionPriceId"] = this.subscriptionPriceId;
        data["subscriptionCurrentPeriodEndUtc"] = this.subscriptionCurrentPeriodEndUtc ? this.subscriptionCurrentPeriodEndUtc.toISOString() : <any>undefined;
        data["accountDeletedDateUtc"] = this.accountDeletedDateUtc ? this.accountDeletedDateUtc.toISOString() : <any>undefined;
        data["continuationMessageId"] = this.continuationMessageId;
        data["isRestrictedAccess"] = this.isRestrictedAccess;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["assistantPreferences"] = this.assistantPreferences ? this.assistantPreferences.toJSON() : <any>undefined;
        data["nutritionixRemoteUserId"] = this.nutritionixRemoteUserId;
        data["marketingEmailsOptIn"] = this.marketingEmailsOptIn;
        data["referrer"] = this.referrer;
        data["referrerId"] = this.referrerId;
        data["onboardingProgress"] = this.onboardingProgress ? this.onboardingProgress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccount {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    name?: string | undefined;
    email?: string | undefined;
    timeZoneId?: string | undefined;
    clientPlatform?: string | undefined;
    isOwner?: boolean;
    isEarlyAccess?: boolean;
    hasUnacknowledgedAssistantResponses?: boolean;
    canDelete?: boolean;
    canClear?: boolean;
    automaticNotificationsEnabled?: boolean;
    trialEndDateUtc?: Date | undefined;
    isPremium?: boolean;
    isPremiumLifetime?: boolean;
    subscriptionStatus?: SubscriptionStatus;
    stripeCustomerId?: string | undefined;
    stripeSubscriptionId?: string | undefined;
    subscriptionPriceId?: string | undefined;
    subscriptionCurrentPeriodEndUtc?: Date | undefined;
    accountDeletedDateUtc?: Date | undefined;
    continuationMessageId?: string | undefined;
    isRestrictedAccess?: boolean;
    restrictedAccessPhase?: string | undefined;
    assistantPreferences?: CommunicationPreferences;
    nutritionixRemoteUserId?: string | undefined;
    marketingEmailsOptIn?: boolean;
    referrer?: string | undefined;
    referrerId?: string | undefined;
    onboardingProgress?: OnboardingProgress;
}

export class AccountInfoResponse implements IAccountInfoResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    email?: string | undefined;
    createdDateUtc?: Date;
    trialEndDateUtc?: Date | undefined;
    isPremium?: boolean;
    isPremiumLifetime?: boolean;
    isEarlyAccess?: boolean;
    subscriptionStatus?: SubscriptionStatus;
    subscriptionCurrentPeriodEndUtc?: Date | undefined;
    subscriptionPriceId?: string | undefined;

    constructor(data?: IAccountInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.email = _data["email"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.trialEndDateUtc = _data["trialEndDateUtc"] ? new Date(_data["trialEndDateUtc"].toString()) : <any>undefined;
            this.isPremium = _data["isPremium"];
            this.isPremiumLifetime = _data["isPremiumLifetime"];
            this.isEarlyAccess = _data["isEarlyAccess"];
            this.subscriptionStatus = _data["subscriptionStatus"];
            this.subscriptionCurrentPeriodEndUtc = _data["subscriptionCurrentPeriodEndUtc"] ? new Date(_data["subscriptionCurrentPeriodEndUtc"].toString()) : <any>undefined;
            this.subscriptionPriceId = _data["subscriptionPriceId"];
        }
    }

    static fromJS(data: any): AccountInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["email"] = this.email;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["trialEndDateUtc"] = this.trialEndDateUtc ? this.trialEndDateUtc.toISOString() : <any>undefined;
        data["isPremium"] = this.isPremium;
        data["isPremiumLifetime"] = this.isPremiumLifetime;
        data["isEarlyAccess"] = this.isEarlyAccess;
        data["subscriptionStatus"] = this.subscriptionStatus;
        data["subscriptionCurrentPeriodEndUtc"] = this.subscriptionCurrentPeriodEndUtc ? this.subscriptionCurrentPeriodEndUtc.toISOString() : <any>undefined;
        data["subscriptionPriceId"] = this.subscriptionPriceId;
        return data;
    }
}

export interface IAccountInfoResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    email?: string | undefined;
    createdDateUtc?: Date;
    trialEndDateUtc?: Date | undefined;
    isPremium?: boolean;
    isPremiumLifetime?: boolean;
    isEarlyAccess?: boolean;
    subscriptionStatus?: SubscriptionStatus;
    subscriptionCurrentPeriodEndUtc?: Date | undefined;
    subscriptionPriceId?: string | undefined;
}

export class AccountResponse implements IAccountResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    account?: Account;

    constructor(data?: IAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    account?: Account;
}

export class ActiveFoodLogRequest implements IActiveFoodLogRequest {
    messageId?: string | undefined;
    text?: string | undefined;
    localDateKey?: string | undefined;
    images?: string[] | undefined;

    constructor(data?: IActiveFoodLogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.text = _data["text"];
            this.localDateKey = _data["localDateKey"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
        }
    }

    static fromJS(data: any): ActiveFoodLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveFoodLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["text"] = this.text;
        data["localDateKey"] = this.localDateKey;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }
}

export interface IActiveFoodLogRequest {
    messageId?: string | undefined;
    text?: string | undefined;
    localDateKey?: string | undefined;
    images?: string[] | undefined;
}

export class AdjustAccountDatesRequest implements IAdjustAccountDatesRequest {
    accountId?: string | undefined;
    dayShift?: number;

    constructor(data?: IAdjustAccountDatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.dayShift = _data["dayShift"];
        }
    }

    static fromJS(data: any): AdjustAccountDatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustAccountDatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["dayShift"] = this.dayShift;
        return data;
    }
}

export interface IAdjustAccountDatesRequest {
    accountId?: string | undefined;
    dayShift?: number;
}

export class AdjustAccountDatesResponse implements IAdjustAccountDatesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accountId?: string | undefined;
    dayShift?: number;
    chatMessagesUpdated?: number;
    foodEntriesUpdated?: number;
    dailySummariesUpdated?: number;
    userProfilesUpdated?: number;
    dailyTargetsUpdated?: number;
    mealSelectionsUpdated?: number;
    foodFavoritesUpdated?: number;
    chatMessagesDeleted?: number;
    foodEntriesDeleted?: number;
    dailySummariesDeleted?: number;
    userProfilesDeleted?: number;
    dailyTargetsDeleted?: number;
    mealSelectionsDeleted?: number;
    readonly totalUpdated?: number;
    readonly totalDeleted?: number;

    constructor(data?: IAdjustAccountDatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.accountId = _data["accountId"];
            this.dayShift = _data["dayShift"];
            this.chatMessagesUpdated = _data["chatMessagesUpdated"];
            this.foodEntriesUpdated = _data["foodEntriesUpdated"];
            this.dailySummariesUpdated = _data["dailySummariesUpdated"];
            this.userProfilesUpdated = _data["userProfilesUpdated"];
            this.dailyTargetsUpdated = _data["dailyTargetsUpdated"];
            this.mealSelectionsUpdated = _data["mealSelectionsUpdated"];
            this.foodFavoritesUpdated = _data["foodFavoritesUpdated"];
            this.chatMessagesDeleted = _data["chatMessagesDeleted"];
            this.foodEntriesDeleted = _data["foodEntriesDeleted"];
            this.dailySummariesDeleted = _data["dailySummariesDeleted"];
            this.userProfilesDeleted = _data["userProfilesDeleted"];
            this.dailyTargetsDeleted = _data["dailyTargetsDeleted"];
            this.mealSelectionsDeleted = _data["mealSelectionsDeleted"];
            (<any>this).totalUpdated = _data["totalUpdated"];
            (<any>this).totalDeleted = _data["totalDeleted"];
        }
    }

    static fromJS(data: any): AdjustAccountDatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustAccountDatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["accountId"] = this.accountId;
        data["dayShift"] = this.dayShift;
        data["chatMessagesUpdated"] = this.chatMessagesUpdated;
        data["foodEntriesUpdated"] = this.foodEntriesUpdated;
        data["dailySummariesUpdated"] = this.dailySummariesUpdated;
        data["userProfilesUpdated"] = this.userProfilesUpdated;
        data["dailyTargetsUpdated"] = this.dailyTargetsUpdated;
        data["mealSelectionsUpdated"] = this.mealSelectionsUpdated;
        data["foodFavoritesUpdated"] = this.foodFavoritesUpdated;
        data["chatMessagesDeleted"] = this.chatMessagesDeleted;
        data["foodEntriesDeleted"] = this.foodEntriesDeleted;
        data["dailySummariesDeleted"] = this.dailySummariesDeleted;
        data["userProfilesDeleted"] = this.userProfilesDeleted;
        data["dailyTargetsDeleted"] = this.dailyTargetsDeleted;
        data["mealSelectionsDeleted"] = this.mealSelectionsDeleted;
        data["totalUpdated"] = this.totalUpdated;
        data["totalDeleted"] = this.totalDeleted;
        return data;
    }
}

export interface IAdjustAccountDatesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accountId?: string | undefined;
    dayShift?: number;
    chatMessagesUpdated?: number;
    foodEntriesUpdated?: number;
    dailySummariesUpdated?: number;
    userProfilesUpdated?: number;
    dailyTargetsUpdated?: number;
    mealSelectionsUpdated?: number;
    foodFavoritesUpdated?: number;
    chatMessagesDeleted?: number;
    foodEntriesDeleted?: number;
    dailySummariesDeleted?: number;
    userProfilesDeleted?: number;
    dailyTargetsDeleted?: number;
    mealSelectionsDeleted?: number;
    totalUpdated?: number;
    totalDeleted?: number;
}

export class AppleExportMeal implements IAppleExportMeal {
    mealId?: string | undefined;
    stableIdentifier?: string | undefined;
    version?: number;
    name?: string | undefined;
    startDate?: Date;
    energyKcal?: number | undefined;
    proteinGrams?: number | undefined;
    carbohydrateGrams?: number | undefined;
    fatGrams?: number | undefined;
    operation?: string | undefined;

    constructor(data?: IAppleExportMeal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mealId = _data["mealId"];
            this.stableIdentifier = _data["stableIdentifier"];
            this.version = _data["version"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.energyKcal = _data["energyKcal"];
            this.proteinGrams = _data["proteinGrams"];
            this.carbohydrateGrams = _data["carbohydrateGrams"];
            this.fatGrams = _data["fatGrams"];
            this.operation = _data["operation"];
        }
    }

    static fromJS(data: any): AppleExportMeal {
        data = typeof data === 'object' ? data : {};
        let result = new AppleExportMeal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mealId"] = this.mealId;
        data["stableIdentifier"] = this.stableIdentifier;
        data["version"] = this.version;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["energyKcal"] = this.energyKcal;
        data["proteinGrams"] = this.proteinGrams;
        data["carbohydrateGrams"] = this.carbohydrateGrams;
        data["fatGrams"] = this.fatGrams;
        data["operation"] = this.operation;
        return data;
    }
}

export interface IAppleExportMeal {
    mealId?: string | undefined;
    stableIdentifier?: string | undefined;
    version?: number;
    name?: string | undefined;
    startDate?: Date;
    energyKcal?: number | undefined;
    proteinGrams?: number | undefined;
    carbohydrateGrams?: number | undefined;
    fatGrams?: number | undefined;
    operation?: string | undefined;
}

export class AppleOutboundAck implements IAppleOutboundAck {
    installationId?: string | undefined;
    mealId?: string | undefined;
    stableIdentifier?: string | undefined;
    version?: number;
    platform?: string | undefined;

    constructor(data?: IAppleOutboundAck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.mealId = _data["mealId"];
            this.stableIdentifier = _data["stableIdentifier"];
            this.version = _data["version"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): AppleOutboundAck {
        data = typeof data === 'object' ? data : {};
        let result = new AppleOutboundAck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["mealId"] = this.mealId;
        data["stableIdentifier"] = this.stableIdentifier;
        data["version"] = this.version;
        data["platform"] = this.platform;
        return data;
    }
}

export interface IAppleOutboundAck {
    installationId?: string | undefined;
    mealId?: string | undefined;
    stableIdentifier?: string | undefined;
    version?: number;
    platform?: string | undefined;
}

export class AppleOutboundFeedRequest implements IAppleOutboundFeedRequest {
    installationId?: string | undefined;
    platform?: string | undefined;
    cursor?: number | undefined;

    constructor(data?: IAppleOutboundFeedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.platform = _data["platform"];
            this.cursor = _data["cursor"];
        }
    }

    static fromJS(data: any): AppleOutboundFeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppleOutboundFeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["platform"] = this.platform;
        data["cursor"] = this.cursor;
        return data;
    }
}

export interface IAppleOutboundFeedRequest {
    installationId?: string | undefined;
    platform?: string | undefined;
    cursor?: number | undefined;
}

export class AppleOutboundFeedResponse implements IAppleOutboundFeedResponse {
    meals?: AppleExportMeal[] | undefined;
    nextCursor?: number | undefined;
    totalCount?: number;

    constructor(data?: IAppleOutboundFeedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["meals"])) {
                this.meals = [] as any;
                for (let item of _data["meals"])
                    this.meals!.push(AppleExportMeal.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AppleOutboundFeedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppleOutboundFeedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.meals)) {
            data["meals"] = [];
            for (let item of this.meals)
                data["meals"].push(item.toJSON());
        }
        data["nextCursor"] = this.nextCursor;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IAppleOutboundFeedResponse {
    meals?: AppleExportMeal[] | undefined;
    nextCursor?: number | undefined;
    totalCount?: number;
}

export enum AssistantModeTypes {
    Default = "Default",
    GoalSetting = "GoalSetting",
    UserFeedback = "UserFeedback",
    RestrictedAccess = "RestrictedAccess",
    AssistantPreferences = "AssistantPreferences",
    NotificationPreferences = "NotificationPreferences",
    FoodLogging = "FoodLogging",
}

export class BarcodeSearchRequest implements IBarcodeSearchRequest {
    upc?: string | undefined;
    messageId?: string | undefined;

    constructor(data?: IBarcodeSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upc = _data["upc"];
            this.messageId = _data["messageId"];
        }
    }

    static fromJS(data: any): BarcodeSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodeSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upc"] = this.upc;
        data["messageId"] = this.messageId;
        return data;
    }
}

export interface IBarcodeSearchRequest {
    upc?: string | undefined;
    messageId?: string | undefined;
}

export class BuildStamp implements IBuildStamp {
    appVersion?: string | undefined;
    previousCommitHash?: string | undefined;

    constructor(data?: IBuildStamp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appVersion = _data["appVersion"];
            this.previousCommitHash = _data["previousCommitHash"];
        }
    }

    static fromJS(data: any): BuildStamp {
        data = typeof data === 'object' ? data : {};
        let result = new BuildStamp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appVersion"] = this.appVersion;
        data["previousCommitHash"] = this.previousCommitHash;
        return data;
    }
}

export interface IBuildStamp {
    appVersion?: string | undefined;
    previousCommitHash?: string | undefined;
}

export class BulkNotificationAccountResult implements IBulkNotificationAccountResult {
    accountId?: string | undefined;
    email?: string | undefined;
    devicesSent?: number;
    devicesFailed?: number;
    errorMessage?: string | undefined;

    constructor(data?: IBulkNotificationAccountResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.email = _data["email"];
            this.devicesSent = _data["devicesSent"];
            this.devicesFailed = _data["devicesFailed"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BulkNotificationAccountResult {
        data = typeof data === 'object' ? data : {};
        let result = new BulkNotificationAccountResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["email"] = this.email;
        data["devicesSent"] = this.devicesSent;
        data["devicesFailed"] = this.devicesFailed;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBulkNotificationAccountResult {
    accountId?: string | undefined;
    email?: string | undefined;
    devicesSent?: number;
    devicesFailed?: number;
    errorMessage?: string | undefined;
}

export class CancelEditSelectionRequest implements ICancelEditSelectionRequest {
    pendingMessageId?: string | undefined;
    localDateKey?: string | undefined;

    constructor(data?: ICancelEditSelectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingMessageId = _data["pendingMessageId"];
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): CancelEditSelectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelEditSelectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingMessageId"] = this.pendingMessageId;
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface ICancelEditSelectionRequest {
    pendingMessageId?: string | undefined;
    localDateKey?: string | undefined;
}

export class CancelServingSelectionRequest implements ICancelServingSelectionRequest {
    pendingMessageId?: string | undefined;
    localDateKey?: string | undefined;

    constructor(data?: ICancelServingSelectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingMessageId = _data["pendingMessageId"];
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): CancelServingSelectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelServingSelectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingMessageId"] = this.pendingMessageId;
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface ICancelServingSelectionRequest {
    pendingMessageId?: string | undefined;
    localDateKey?: string | undefined;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordRequest {
    newPassword?: string | undefined;
}

export class ChatMessage implements IChatMessage {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    accountId?: string | undefined;
    role?: MessageRoleTypes;
    content?: string | undefined;
    localDateKey?: string | undefined;
    foodEntryIds?: string[] | undefined;
    isRead?: boolean;
    toolCallId?: string | undefined;
    toolFunctionName?: string | undefined;
    toolCallArgumentsJson?: string | undefined;
    responseId?: string | undefined;
    assistantMode?: AssistantModeTypes;
    assistantPhase?: string | undefined;
    pendingMealSelectionId?: string | undefined;
    mealSelections?: MealSelection[] | undefined;
    retryCount?: number;
    modelUsed?: string | undefined;
    promptTokens?: number | undefined;
    completionTokens?: number | undefined;
    totalTokens?: number | undefined;
    hasActionButtons?: boolean;
    systemTag?: string | undefined;
    sessionId?: string | undefined;
    attachedPhotoObjectNames?: string[] | undefined;
    attachedPhotoUrls?: string[] | undefined;

    constructor(data?: IChatMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.lastUpdatedDateUtc = _data["lastUpdatedDateUtc"] ? new Date(_data["lastUpdatedDateUtc"].toString()) : <any>undefined;
            this.accountId = _data["accountId"];
            this.role = _data["role"];
            this.content = _data["content"];
            this.localDateKey = _data["localDateKey"];
            if (Array.isArray(_data["foodEntryIds"])) {
                this.foodEntryIds = [] as any;
                for (let item of _data["foodEntryIds"])
                    this.foodEntryIds!.push(item);
            }
            this.isRead = _data["isRead"];
            this.toolCallId = _data["toolCallId"];
            this.toolFunctionName = _data["toolFunctionName"];
            this.toolCallArgumentsJson = _data["toolCallArgumentsJson"];
            this.responseId = _data["responseId"];
            this.assistantMode = _data["assistantMode"];
            this.assistantPhase = _data["assistantPhase"];
            this.pendingMealSelectionId = _data["pendingMealSelectionId"];
            if (Array.isArray(_data["mealSelections"])) {
                this.mealSelections = [] as any;
                for (let item of _data["mealSelections"])
                    this.mealSelections!.push(MealSelection.fromJS(item));
            }
            this.retryCount = _data["retryCount"];
            this.modelUsed = _data["modelUsed"];
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
            this.totalTokens = _data["totalTokens"];
            this.hasActionButtons = _data["hasActionButtons"];
            this.systemTag = _data["systemTag"];
            this.sessionId = _data["sessionId"];
            if (Array.isArray(_data["attachedPhotoObjectNames"])) {
                this.attachedPhotoObjectNames = [] as any;
                for (let item of _data["attachedPhotoObjectNames"])
                    this.attachedPhotoObjectNames!.push(item);
            }
            if (Array.isArray(_data["attachedPhotoUrls"])) {
                this.attachedPhotoUrls = [] as any;
                for (let item of _data["attachedPhotoUrls"])
                    this.attachedPhotoUrls!.push(item);
            }
        }
    }

    static fromJS(data: any): ChatMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["lastUpdatedDateUtc"] = this.lastUpdatedDateUtc ? this.lastUpdatedDateUtc.toISOString() : <any>undefined;
        data["accountId"] = this.accountId;
        data["role"] = this.role;
        data["content"] = this.content;
        data["localDateKey"] = this.localDateKey;
        if (Array.isArray(this.foodEntryIds)) {
            data["foodEntryIds"] = [];
            for (let item of this.foodEntryIds)
                data["foodEntryIds"].push(item);
        }
        data["isRead"] = this.isRead;
        data["toolCallId"] = this.toolCallId;
        data["toolFunctionName"] = this.toolFunctionName;
        data["toolCallArgumentsJson"] = this.toolCallArgumentsJson;
        data["responseId"] = this.responseId;
        data["assistantMode"] = this.assistantMode;
        data["assistantPhase"] = this.assistantPhase;
        data["pendingMealSelectionId"] = this.pendingMealSelectionId;
        if (Array.isArray(this.mealSelections)) {
            data["mealSelections"] = [];
            for (let item of this.mealSelections)
                data["mealSelections"].push(item.toJSON());
        }
        data["retryCount"] = this.retryCount;
        data["modelUsed"] = this.modelUsed;
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        data["totalTokens"] = this.totalTokens;
        data["hasActionButtons"] = this.hasActionButtons;
        data["systemTag"] = this.systemTag;
        data["sessionId"] = this.sessionId;
        if (Array.isArray(this.attachedPhotoObjectNames)) {
            data["attachedPhotoObjectNames"] = [];
            for (let item of this.attachedPhotoObjectNames)
                data["attachedPhotoObjectNames"].push(item);
        }
        if (Array.isArray(this.attachedPhotoUrls)) {
            data["attachedPhotoUrls"] = [];
            for (let item of this.attachedPhotoUrls)
                data["attachedPhotoUrls"].push(item);
        }
        return data;
    }
}

export interface IChatMessage {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    accountId?: string | undefined;
    role?: MessageRoleTypes;
    content?: string | undefined;
    localDateKey?: string | undefined;
    foodEntryIds?: string[] | undefined;
    isRead?: boolean;
    toolCallId?: string | undefined;
    toolFunctionName?: string | undefined;
    toolCallArgumentsJson?: string | undefined;
    responseId?: string | undefined;
    assistantMode?: AssistantModeTypes;
    assistantPhase?: string | undefined;
    pendingMealSelectionId?: string | undefined;
    mealSelections?: MealSelection[] | undefined;
    retryCount?: number;
    modelUsed?: string | undefined;
    promptTokens?: number | undefined;
    completionTokens?: number | undefined;
    totalTokens?: number | undefined;
    hasActionButtons?: boolean;
    systemTag?: string | undefined;
    sessionId?: string | undefined;
    attachedPhotoObjectNames?: string[] | undefined;
    attachedPhotoUrls?: string[] | undefined;
}

export class ChatMessagesResponse implements IChatMessagesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    messages?: ChatMessage[] | undefined;
    needsContinuation?: boolean;

    constructor(data?: IChatMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ChatMessage.fromJS(item));
            }
            this.needsContinuation = _data["needsContinuation"];
        }
    }

    static fromJS(data: any): ChatMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["needsContinuation"] = this.needsContinuation;
        return data;
    }
}

export interface IChatMessagesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    messages?: ChatMessage[] | undefined;
    needsContinuation?: boolean;
}

export class CheckFcmTokenRequest implements ICheckFcmTokenRequest {
    accountId?: string | undefined;

    constructor(data?: ICheckFcmTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): CheckFcmTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckFcmTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface ICheckFcmTokenRequest {
    accountId?: string | undefined;
}

export class CheckFcmTokenResponse implements ICheckFcmTokenResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    hasFcmToken?: boolean;

    constructor(data?: ICheckFcmTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.hasFcmToken = _data["hasFcmToken"];
        }
    }

    static fromJS(data: any): CheckFcmTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckFcmTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["hasFcmToken"] = this.hasFcmToken;
        return data;
    }
}

export interface ICheckFcmTokenResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    hasFcmToken?: boolean;
}

export class ClearAccountDataRequest implements IClearAccountDataRequest {
    accountId?: string | undefined;
    confirmClear?: boolean;

    constructor(data?: IClearAccountDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.confirmClear = _data["confirmClear"];
        }
    }

    static fromJS(data: any): ClearAccountDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClearAccountDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["confirmClear"] = this.confirmClear;
        return data;
    }
}

export interface IClearAccountDataRequest {
    accountId?: string | undefined;
    confirmClear?: boolean;
}

export class ClearAccountDataResponse implements IClearAccountDataResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    dataCleared?: boolean;
    clearedAccountId?: string | undefined;
    totalRecordsDeleted?: number;
    deletedRecordsByType?: { [key: string]: number; } | undefined;

    constructor(data?: IClearAccountDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.dataCleared = _data["dataCleared"];
            this.clearedAccountId = _data["clearedAccountId"];
            this.totalRecordsDeleted = _data["totalRecordsDeleted"];
            if (_data["deletedRecordsByType"]) {
                this.deletedRecordsByType = {} as any;
                for (let key in _data["deletedRecordsByType"]) {
                    if (_data["deletedRecordsByType"].hasOwnProperty(key))
                        (<any>this.deletedRecordsByType)![key] = _data["deletedRecordsByType"][key];
                }
            }
        }
    }

    static fromJS(data: any): ClearAccountDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClearAccountDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["dataCleared"] = this.dataCleared;
        data["clearedAccountId"] = this.clearedAccountId;
        data["totalRecordsDeleted"] = this.totalRecordsDeleted;
        if (this.deletedRecordsByType) {
            data["deletedRecordsByType"] = {};
            for (let key in this.deletedRecordsByType) {
                if (this.deletedRecordsByType.hasOwnProperty(key))
                    (<any>data["deletedRecordsByType"])[key] = (<any>this.deletedRecordsByType)[key];
            }
        }
        return data;
    }
}

export interface IClearAccountDataResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    dataCleared?: boolean;
    clearedAccountId?: string | undefined;
    totalRecordsDeleted?: number;
    deletedRecordsByType?: { [key: string]: number; } | undefined;
}

export class CommunicationPreferences implements ICommunicationPreferences {
    style?: CommunicationStyle;
    knowledge?: KnowledgeLevel;
    customResponseGuidance?: string | undefined;

    constructor(data?: ICommunicationPreferences) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.style = _data["style"];
            this.knowledge = _data["knowledge"];
            this.customResponseGuidance = _data["customResponseGuidance"];
        }
    }

    static fromJS(data: any): CommunicationPreferences {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationPreferences();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["style"] = this.style;
        data["knowledge"] = this.knowledge;
        data["customResponseGuidance"] = this.customResponseGuidance;
        return data;
    }
}

export interface ICommunicationPreferences {
    style?: CommunicationStyle;
    knowledge?: KnowledgeLevel;
    customResponseGuidance?: string | undefined;
}

export enum CommunicationStyle {
    Concise = "Concise",
    Balanced = "Balanced",
    Detailed = "Detailed",
}

export class CompleteFeedbackRequest implements ICompleteFeedbackRequest {
    feedbackId?: string | undefined;
    completionNote!: string;
    isCompleted?: boolean;

    constructor(data?: ICompleteFeedbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feedbackId = _data["feedbackId"];
            this.completionNote = _data["completionNote"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): CompleteFeedbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteFeedbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedbackId"] = this.feedbackId;
        data["completionNote"] = this.completionNote;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface ICompleteFeedbackRequest {
    feedbackId?: string | undefined;
    completionNote: string;
    isCompleted?: boolean;
}

export class CompleteFeedbackResponse implements ICompleteFeedbackResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    feedbackEntry?: FeedbackEntry;

    constructor(data?: ICompleteFeedbackResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.feedbackEntry = _data["feedbackEntry"] ? FeedbackEntry.fromJS(_data["feedbackEntry"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompleteFeedbackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteFeedbackResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["feedbackEntry"] = this.feedbackEntry ? this.feedbackEntry.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompleteFeedbackResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    feedbackEntry?: FeedbackEntry;
}

export class Component implements IComponent {
    id?: string | undefined;
    selectedComponentId?: string | undefined;
    matches?: ComponentMatch[] | undefined;
    culinaryRole?: string | undefined;
    isPending?: boolean;
    statusText?: string | undefined;

    constructor(data?: IComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selectedComponentId = _data["selectedComponentId"];
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(ComponentMatch.fromJS(item));
            }
            this.culinaryRole = _data["culinaryRole"];
            this.isPending = _data["isPending"];
            this.statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): Component {
        data = typeof data === 'object' ? data : {};
        let result = new Component();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selectedComponentId"] = this.selectedComponentId;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        data["culinaryRole"] = this.culinaryRole;
        data["isPending"] = this.isPending;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IComponent {
    id?: string | undefined;
    selectedComponentId?: string | undefined;
    matches?: ComponentMatch[] | undefined;
    culinaryRole?: string | undefined;
    isPending?: boolean;
    statusText?: string | undefined;
}

export class ComponentBreakdown implements IComponentBreakdown {
    componentId?: string | undefined;
    componentKey?: string | undefined;
    name?: string | undefined;
    brandName?: string | undefined;
    totalAmount?: number;
    unit?: string | undefined;
    inferred?: boolean;
    nutrients?: NutrientContribution[] | undefined;

    constructor(data?: IComponentBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.componentKey = _data["componentKey"];
            this.name = _data["name"];
            this.brandName = _data["brandName"];
            this.totalAmount = _data["totalAmount"];
            this.unit = _data["unit"];
            this.inferred = _data["inferred"];
            if (Array.isArray(_data["nutrients"])) {
                this.nutrients = [] as any;
                for (let item of _data["nutrients"])
                    this.nutrients!.push(NutrientContribution.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["componentKey"] = this.componentKey;
        data["name"] = this.name;
        data["brandName"] = this.brandName;
        data["totalAmount"] = this.totalAmount;
        data["unit"] = this.unit;
        data["inferred"] = this.inferred;
        if (Array.isArray(this.nutrients)) {
            data["nutrients"] = [];
            for (let item of this.nutrients)
                data["nutrients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComponentBreakdown {
    componentId?: string | undefined;
    componentKey?: string | undefined;
    name?: string | undefined;
    brandName?: string | undefined;
    totalAmount?: number;
    unit?: string | undefined;
    inferred?: boolean;
    nutrients?: NutrientContribution[] | undefined;
}

export class ComponentDescription implements IComponentDescription {
    id?: string | undefined;
    name?: string | undefined;
    quantity?: number | undefined;
    singularUnit?: string | undefined;
    pluralUnit?: string | undefined;
    culinaryRole?: string | undefined;

    constructor(data?: IComponentDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.singularUnit = _data["singularUnit"];
            this.pluralUnit = _data["pluralUnit"];
            this.culinaryRole = _data["culinaryRole"];
        }
    }

    static fromJS(data: any): ComponentDescription {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["singularUnit"] = this.singularUnit;
        data["pluralUnit"] = this.pluralUnit;
        data["culinaryRole"] = this.culinaryRole;
        return data;
    }
}

export interface IComponentDescription {
    id?: string | undefined;
    name?: string | undefined;
    quantity?: number | undefined;
    singularUnit?: string | undefined;
    pluralUnit?: string | undefined;
    culinaryRole?: string | undefined;
}

export class ComponentMatch implements IComponentMatch {
    id?: string | undefined;
    provider?: string | undefined;
    providerFoodId?: string | undefined;
    displayName?: string | undefined;
    brandName?: string | undefined;
    originalText?: string | undefined;
    description?: string | undefined;
    cookingMethod?: string | undefined;
    size?: string | undefined;
    rank?: number;
    selectedServingId?: ServingIdentifier;
    totalGrams?: number;
    servings?: ComponentServing[] | undefined;
    effectiveMultiplier?: number;
    effectiveQuantity?: number;
    inferred?: boolean;
    inferredReason?: string | undefined;
    searchText?: string | undefined;
    culinaryRole?: string | undefined;
    photoThumb?: string | undefined;
    photoHighRes?: string | undefined;
    isPending?: boolean;
    statusText?: string | undefined;

    constructor(data?: IComponentMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.provider = _data["provider"];
            this.providerFoodId = _data["providerFoodId"];
            this.displayName = _data["displayName"];
            this.brandName = _data["brandName"];
            this.originalText = _data["originalText"];
            this.description = _data["description"];
            this.cookingMethod = _data["cookingMethod"];
            this.size = _data["size"];
            this.rank = _data["rank"];
            this.selectedServingId = _data["selectedServingId"] ? ServingIdentifier.fromJS(_data["selectedServingId"]) : <any>undefined;
            this.totalGrams = _data["totalGrams"];
            if (Array.isArray(_data["servings"])) {
                this.servings = [] as any;
                for (let item of _data["servings"])
                    this.servings!.push(ComponentServing.fromJS(item));
            }
            this.effectiveMultiplier = _data["effectiveMultiplier"];
            this.effectiveQuantity = _data["effectiveQuantity"];
            this.inferred = _data["inferred"];
            this.inferredReason = _data["inferredReason"];
            this.searchText = _data["searchText"];
            this.culinaryRole = _data["culinaryRole"];
            this.photoThumb = _data["photoThumb"];
            this.photoHighRes = _data["photoHighRes"];
            this.isPending = _data["isPending"];
            this.statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): ComponentMatch {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["provider"] = this.provider;
        data["providerFoodId"] = this.providerFoodId;
        data["displayName"] = this.displayName;
        data["brandName"] = this.brandName;
        data["originalText"] = this.originalText;
        data["description"] = this.description;
        data["cookingMethod"] = this.cookingMethod;
        data["size"] = this.size;
        data["rank"] = this.rank;
        data["selectedServingId"] = this.selectedServingId ? this.selectedServingId.toJSON() : <any>undefined;
        data["totalGrams"] = this.totalGrams;
        if (Array.isArray(this.servings)) {
            data["servings"] = [];
            for (let item of this.servings)
                data["servings"].push(item.toJSON());
        }
        data["effectiveMultiplier"] = this.effectiveMultiplier;
        data["effectiveQuantity"] = this.effectiveQuantity;
        data["inferred"] = this.inferred;
        data["inferredReason"] = this.inferredReason;
        data["searchText"] = this.searchText;
        data["culinaryRole"] = this.culinaryRole;
        data["photoThumb"] = this.photoThumb;
        data["photoHighRes"] = this.photoHighRes;
        data["isPending"] = this.isPending;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IComponentMatch {
    id?: string | undefined;
    provider?: string | undefined;
    providerFoodId?: string | undefined;
    displayName?: string | undefined;
    brandName?: string | undefined;
    originalText?: string | undefined;
    description?: string | undefined;
    cookingMethod?: string | undefined;
    size?: string | undefined;
    rank?: number;
    selectedServingId?: ServingIdentifier;
    totalGrams?: number;
    servings?: ComponentServing[] | undefined;
    effectiveMultiplier?: number;
    effectiveQuantity?: number;
    inferred?: boolean;
    inferredReason?: string | undefined;
    searchText?: string | undefined;
    culinaryRole?: string | undefined;
    photoThumb?: string | undefined;
    photoHighRes?: string | undefined;
    isPending?: boolean;
    statusText?: string | undefined;
}

export class ComponentServing implements IComponentServing {
    id?: string | undefined;
    servingId?: ServingIdentifier;
    description?: string | undefined;
    baseQuantity?: number;
    baseUnit?: string | undefined;
    aiRecommendedScaleNumerator?: number | undefined;
    aiRecommendedScaleDenominator?: number | undefined;
    userConfirmedQuantity?: number | undefined;
    singularUnit?: string | undefined;
    pluralUnit?: string | undefined;
    metricServingAmount?: number | undefined;
    metricServingUnit?: string | undefined;
    numberOfUnits?: number | undefined;
    measurementDescription?: string | undefined;
    nutrients?: { [key: string]: number; } | undefined;
    apiServingKind?: UnitKind;
    nutrientComposition?: { [key: string]: NutrientCompositionEntry[]; } | undefined;
    isPending?: boolean;
    statusText?: string | undefined;

    constructor(data?: IComponentServing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.servingId = _data["servingId"] ? ServingIdentifier.fromJS(_data["servingId"]) : <any>undefined;
            this.description = _data["description"];
            this.baseQuantity = _data["baseQuantity"];
            this.baseUnit = _data["baseUnit"];
            this.aiRecommendedScaleNumerator = _data["aiRecommendedScaleNumerator"];
            this.aiRecommendedScaleDenominator = _data["aiRecommendedScaleDenominator"];
            this.userConfirmedQuantity = _data["userConfirmedQuantity"];
            this.singularUnit = _data["singularUnit"];
            this.pluralUnit = _data["pluralUnit"];
            this.metricServingAmount = _data["metricServingAmount"];
            this.metricServingUnit = _data["metricServingUnit"];
            this.numberOfUnits = _data["numberOfUnits"];
            this.measurementDescription = _data["measurementDescription"];
            if (_data["nutrients"]) {
                this.nutrients = {} as any;
                for (let key in _data["nutrients"]) {
                    if (_data["nutrients"].hasOwnProperty(key))
                        (<any>this.nutrients)![key] = _data["nutrients"][key];
                }
            }
            this.apiServingKind = _data["apiServingKind"];
            if (_data["nutrientComposition"]) {
                this.nutrientComposition = {} as any;
                for (let key in _data["nutrientComposition"]) {
                    if (_data["nutrientComposition"].hasOwnProperty(key))
                        (<any>this.nutrientComposition)![key] = _data["nutrientComposition"][key] ? _data["nutrientComposition"][key].map((i: any) => NutrientCompositionEntry.fromJS(i)) : <any>undefined;
                }
            }
            this.isPending = _data["isPending"];
            this.statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): ComponentServing {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentServing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["servingId"] = this.servingId ? this.servingId.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["baseQuantity"] = this.baseQuantity;
        data["baseUnit"] = this.baseUnit;
        data["aiRecommendedScaleNumerator"] = this.aiRecommendedScaleNumerator;
        data["aiRecommendedScaleDenominator"] = this.aiRecommendedScaleDenominator;
        data["userConfirmedQuantity"] = this.userConfirmedQuantity;
        data["singularUnit"] = this.singularUnit;
        data["pluralUnit"] = this.pluralUnit;
        data["metricServingAmount"] = this.metricServingAmount;
        data["metricServingUnit"] = this.metricServingUnit;
        data["numberOfUnits"] = this.numberOfUnits;
        data["measurementDescription"] = this.measurementDescription;
        if (this.nutrients) {
            data["nutrients"] = {};
            for (let key in this.nutrients) {
                if (this.nutrients.hasOwnProperty(key))
                    (<any>data["nutrients"])[key] = (<any>this.nutrients)[key];
            }
        }
        data["apiServingKind"] = this.apiServingKind;
        if (this.nutrientComposition) {
            data["nutrientComposition"] = {};
            for (let key in this.nutrientComposition) {
                if (this.nutrientComposition.hasOwnProperty(key))
                    (<any>data["nutrientComposition"])[key] = (<any>this.nutrientComposition)[key];
            }
        }
        data["isPending"] = this.isPending;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IComponentServing {
    id?: string | undefined;
    servingId?: ServingIdentifier;
    description?: string | undefined;
    baseQuantity?: number;
    baseUnit?: string | undefined;
    aiRecommendedScaleNumerator?: number | undefined;
    aiRecommendedScaleDenominator?: number | undefined;
    userConfirmedQuantity?: number | undefined;
    singularUnit?: string | undefined;
    pluralUnit?: string | undefined;
    metricServingAmount?: number | undefined;
    metricServingUnit?: string | undefined;
    numberOfUnits?: number | undefined;
    measurementDescription?: string | undefined;
    nutrients?: { [key: string]: number; } | undefined;
    apiServingKind?: UnitKind;
    nutrientComposition?: { [key: string]: NutrientCompositionEntry[]; } | undefined;
    isPending?: boolean;
    statusText?: string | undefined;
}

export class ConfigureAppleOutboundRequest implements IConfigureAppleOutboundRequest {
    installationId?: string | undefined;
    window?: string | undefined;
    platform?: string | undefined;
    timeZoneId?: string | undefined;

    constructor(data?: IConfigureAppleOutboundRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.window = _data["window"];
            this.platform = _data["platform"];
            this.timeZoneId = _data["timeZoneId"];
        }
    }

    static fromJS(data: any): ConfigureAppleOutboundRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigureAppleOutboundRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["window"] = this.window;
        data["platform"] = this.platform;
        data["timeZoneId"] = this.timeZoneId;
        return data;
    }
}

export interface IConfigureAppleOutboundRequest {
    installationId?: string | undefined;
    window?: string | undefined;
    platform?: string | undefined;
    timeZoneId?: string | undefined;
}

export class ConfigureHealthConnectInboundRequest implements IConfigureHealthConnectInboundRequest {
    installationId?: string | undefined;
    window?: string | undefined;
    timeZoneId?: string | undefined;

    constructor(data?: IConfigureHealthConnectInboundRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.window = _data["window"];
            this.timeZoneId = _data["timeZoneId"];
        }
    }

    static fromJS(data: any): ConfigureHealthConnectInboundRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigureHealthConnectInboundRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["window"] = this.window;
        data["timeZoneId"] = this.timeZoneId;
        return data;
    }
}

export interface IConfigureHealthConnectInboundRequest {
    installationId?: string | undefined;
    window?: string | undefined;
    timeZoneId?: string | undefined;
}

export class ConfirmGuidelineFileUploadRequest implements IConfirmGuidelineFileUploadRequest {
    objectName?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IConfirmGuidelineFileUploadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectName = _data["objectName"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): ConfirmGuidelineFileUploadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmGuidelineFileUploadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectName"] = this.objectName;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IConfirmGuidelineFileUploadRequest {
    objectName?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export class ConfirmGuidelineFileUploadResponse implements IConfirmGuidelineFileUploadResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    openAiFileId?: string | undefined;
    openAiFileApiId?: string | undefined;
    vectorStoreId?: string | undefined;
    status?: string | undefined;
    cloudStorageObjectName?: string | undefined;

    constructor(data?: IConfirmGuidelineFileUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.openAiFileId = _data["openAiFileId"];
            this.openAiFileApiId = _data["openAiFileApiId"];
            this.vectorStoreId = _data["vectorStoreId"];
            this.status = _data["status"];
            this.cloudStorageObjectName = _data["cloudStorageObjectName"];
        }
    }

    static fromJS(data: any): ConfirmGuidelineFileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmGuidelineFileUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["openAiFileId"] = this.openAiFileId;
        data["openAiFileApiId"] = this.openAiFileApiId;
        data["vectorStoreId"] = this.vectorStoreId;
        data["status"] = this.status;
        data["cloudStorageObjectName"] = this.cloudStorageObjectName;
        return data;
    }
}

export interface IConfirmGuidelineFileUploadResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    openAiFileId?: string | undefined;
    openAiFileApiId?: string | undefined;
    vectorStoreId?: string | undefined;
    status?: string | undefined;
    cloudStorageObjectName?: string | undefined;
}

export class CreateAuthHandoffTokenResponse implements ICreateAuthHandoffTokenResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    handoffUrl?: string | undefined;

    constructor(data?: ICreateAuthHandoffTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.handoffUrl = _data["handoffUrl"];
        }
    }

    static fromJS(data: any): CreateAuthHandoffTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAuthHandoffTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["handoffUrl"] = this.handoffUrl;
        return data;
    }
}

export interface ICreateAuthHandoffTokenResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    handoffUrl?: string | undefined;
}

export class CreateCheckoutSessionRequest implements ICreateCheckoutSessionRequest {
    priceId?: string | undefined;
    isLifetime?: boolean;

    constructor(data?: ICreateCheckoutSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceId = _data["priceId"];
            this.isLifetime = _data["isLifetime"];
        }
    }

    static fromJS(data: any): CreateCheckoutSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCheckoutSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceId"] = this.priceId;
        data["isLifetime"] = this.isLifetime;
        return data;
    }
}

export interface ICreateCheckoutSessionRequest {
    priceId?: string | undefined;
    isLifetime?: boolean;
}

export class CreateCheckoutSessionResponse implements ICreateCheckoutSessionResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    checkoutUrl?: string | undefined;

    constructor(data?: ICreateCheckoutSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.checkoutUrl = _data["checkoutUrl"];
        }
    }

    static fromJS(data: any): CreateCheckoutSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCheckoutSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["checkoutUrl"] = this.checkoutUrl;
        return data;
    }
}

export interface ICreateCheckoutSessionResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    checkoutUrl?: string | undefined;
}

export class CreateSharedMealRequest implements ICreateSharedMealRequest {
    foodEntryId?: string | undefined;

    constructor(data?: ICreateSharedMealRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.foodEntryId = _data["foodEntryId"];
        }
    }

    static fromJS(data: any): CreateSharedMealRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSharedMealRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foodEntryId"] = this.foodEntryId;
        return data;
    }
}

export interface ICreateSharedMealRequest {
    foodEntryId?: string | undefined;
}

export class CreateSharedMealResponse implements ICreateSharedMealResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    shareToken?: string | undefined;
    shareUrl?: string | undefined;
    preview?: MealPreview;
    expiresDateUtc?: Date;

    constructor(data?: ICreateSharedMealResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.shareToken = _data["shareToken"];
            this.shareUrl = _data["shareUrl"];
            this.preview = _data["preview"] ? MealPreview.fromJS(_data["preview"]) : <any>undefined;
            this.expiresDateUtc = _data["expiresDateUtc"] ? new Date(_data["expiresDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateSharedMealResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSharedMealResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["shareToken"] = this.shareToken;
        data["shareUrl"] = this.shareUrl;
        data["preview"] = this.preview ? this.preview.toJSON() : <any>undefined;
        data["expiresDateUtc"] = this.expiresDateUtc ? this.expiresDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateSharedMealResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    shareToken?: string | undefined;
    shareUrl?: string | undefined;
    preview?: MealPreview;
    expiresDateUtc?: Date;
}

export class DailyEnergyUpload implements IDailyEnergyUpload {
    localDate?: string | undefined;
    activeCaloriesKcal?: number | undefined;
    totalCaloriesKcal?: number | undefined;
    totalMethod?: EnergyTotalMethod;
    observationStartUtc?: Date;
    observationEndUtc?: Date;
    timeZoneId?: string | undefined;
    coverageState?: EnergyCoverageState;

    constructor(data?: IDailyEnergyUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDate = _data["localDate"];
            this.activeCaloriesKcal = _data["activeCaloriesKcal"];
            this.totalCaloriesKcal = _data["totalCaloriesKcal"];
            this.totalMethod = _data["totalMethod"];
            this.observationStartUtc = _data["observationStartUtc"] ? new Date(_data["observationStartUtc"].toString()) : <any>undefined;
            this.observationEndUtc = _data["observationEndUtc"] ? new Date(_data["observationEndUtc"].toString()) : <any>undefined;
            this.timeZoneId = _data["timeZoneId"];
            this.coverageState = _data["coverageState"];
        }
    }

    static fromJS(data: any): DailyEnergyUpload {
        data = typeof data === 'object' ? data : {};
        let result = new DailyEnergyUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDate"] = this.localDate;
        data["activeCaloriesKcal"] = this.activeCaloriesKcal;
        data["totalCaloriesKcal"] = this.totalCaloriesKcal;
        data["totalMethod"] = this.totalMethod;
        data["observationStartUtc"] = this.observationStartUtc ? this.observationStartUtc.toISOString() : <any>undefined;
        data["observationEndUtc"] = this.observationEndUtc ? this.observationEndUtc.toISOString() : <any>undefined;
        data["timeZoneId"] = this.timeZoneId;
        data["coverageState"] = this.coverageState;
        return data;
    }
}

export interface IDailyEnergyUpload {
    localDate?: string | undefined;
    activeCaloriesKcal?: number | undefined;
    totalCaloriesKcal?: number | undefined;
    totalMethod?: EnergyTotalMethod;
    observationStartUtc?: Date;
    observationEndUtc?: Date;
    timeZoneId?: string | undefined;
    coverageState?: EnergyCoverageState;
}

export class DailySummary implements IDailySummary {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    accountId?: string | undefined;
    localDateKey?: string | undefined;
    nutrients?: NutrientBreakdown[] | undefined;
    foods?: FoodBreakdown[] | undefined;
    foodEntries?: FoodEntryBreakdown[] | undefined;

    constructor(data?: IDailySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.lastUpdatedDateUtc = _data["lastUpdatedDateUtc"] ? new Date(_data["lastUpdatedDateUtc"].toString()) : <any>undefined;
            this.accountId = _data["accountId"];
            this.localDateKey = _data["localDateKey"];
            if (Array.isArray(_data["nutrients"])) {
                this.nutrients = [] as any;
                for (let item of _data["nutrients"])
                    this.nutrients!.push(NutrientBreakdown.fromJS(item));
            }
            if (Array.isArray(_data["foods"])) {
                this.foods = [] as any;
                for (let item of _data["foods"])
                    this.foods!.push(FoodBreakdown.fromJS(item));
            }
            if (Array.isArray(_data["foodEntries"])) {
                this.foodEntries = [] as any;
                for (let item of _data["foodEntries"])
                    this.foodEntries!.push(FoodEntryBreakdown.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailySummary {
        data = typeof data === 'object' ? data : {};
        let result = new DailySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["lastUpdatedDateUtc"] = this.lastUpdatedDateUtc ? this.lastUpdatedDateUtc.toISOString() : <any>undefined;
        data["accountId"] = this.accountId;
        data["localDateKey"] = this.localDateKey;
        if (Array.isArray(this.nutrients)) {
            data["nutrients"] = [];
            for (let item of this.nutrients)
                data["nutrients"].push(item.toJSON());
        }
        if (Array.isArray(this.foods)) {
            data["foods"] = [];
            for (let item of this.foods)
                data["foods"].push(item.toJSON());
        }
        if (Array.isArray(this.foodEntries)) {
            data["foodEntries"] = [];
            for (let item of this.foodEntries)
                data["foodEntries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDailySummary {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    accountId?: string | undefined;
    localDateKey?: string | undefined;
    nutrients?: NutrientBreakdown[] | undefined;
    foods?: FoodBreakdown[] | undefined;
    foodEntries?: FoodEntryBreakdown[] | undefined;
}

export class DeleteAccountRequest implements IDeleteAccountRequest {
    accountId!: string;
    confirmDelete?: boolean;

    constructor(data?: IDeleteAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.confirmDelete = _data["confirmDelete"];
        }
    }

    static fromJS(data: any): DeleteAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["confirmDelete"] = this.confirmDelete;
        return data;
    }
}

export interface IDeleteAccountRequest {
    accountId: string;
    confirmDelete?: boolean;
}

export class DeleteAccountResponse implements IDeleteAccountResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accountDeleted?: boolean;
    deletedAccountId?: string | undefined;
    totalRecordsDeleted?: number;
    deletedRecordsByType?: { [key: string]: number; } | undefined;

    constructor(data?: IDeleteAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.accountDeleted = _data["accountDeleted"];
            this.deletedAccountId = _data["deletedAccountId"];
            this.totalRecordsDeleted = _data["totalRecordsDeleted"];
            if (_data["deletedRecordsByType"]) {
                this.deletedRecordsByType = {} as any;
                for (let key in _data["deletedRecordsByType"]) {
                    if (_data["deletedRecordsByType"].hasOwnProperty(key))
                        (<any>this.deletedRecordsByType)![key] = _data["deletedRecordsByType"][key];
                }
            }
        }
    }

    static fromJS(data: any): DeleteAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["accountDeleted"] = this.accountDeleted;
        data["deletedAccountId"] = this.deletedAccountId;
        data["totalRecordsDeleted"] = this.totalRecordsDeleted;
        if (this.deletedRecordsByType) {
            data["deletedRecordsByType"] = {};
            for (let key in this.deletedRecordsByType) {
                if (this.deletedRecordsByType.hasOwnProperty(key))
                    (<any>data["deletedRecordsByType"])[key] = (<any>this.deletedRecordsByType)[key];
            }
        }
        return data;
    }
}

export interface IDeleteAccountResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accountDeleted?: boolean;
    deletedAccountId?: string | undefined;
    totalRecordsDeleted?: number;
    deletedRecordsByType?: { [key: string]: number; } | undefined;
}

export class DeleteFeedbackRequest implements IDeleteFeedbackRequest {
    feedbackId?: string | undefined;

    constructor(data?: IDeleteFeedbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feedbackId = _data["feedbackId"];
        }
    }

    static fromJS(data: any): DeleteFeedbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFeedbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedbackId"] = this.feedbackId;
        return data;
    }
}

export interface IDeleteFeedbackRequest {
    feedbackId?: string | undefined;
}

export class DeleteFeedbackResponse implements IDeleteFeedbackResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    deleted?: boolean;

    constructor(data?: IDeleteFeedbackResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): DeleteFeedbackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFeedbackResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface IDeleteFeedbackResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    deleted?: boolean;
}

export class DeleteFoodEntryRequest implements IDeleteFoodEntryRequest {
    foodItemIds?: string[] | undefined;

    constructor(data?: IDeleteFoodEntryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["foodItemIds"])) {
                this.foodItemIds = [] as any;
                for (let item of _data["foodItemIds"])
                    this.foodItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteFoodEntryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFoodEntryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.foodItemIds)) {
            data["foodItemIds"] = [];
            for (let item of this.foodItemIds)
                data["foodItemIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteFoodEntryRequest {
    foodItemIds?: string[] | undefined;
}

export class DeleteFoodEntryResponse implements IDeleteFoodEntryResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;

    constructor(data?: IDeleteFoodEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
        }
    }

    static fromJS(data: any): DeleteFoodEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFoodEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        return data;
    }
}

export interface IDeleteFoodEntryResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
}

export class DeleteGuidelineFileRequest implements IDeleteGuidelineFileRequest {
    openAiFileId?: string | undefined;

    constructor(data?: IDeleteGuidelineFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openAiFileId = _data["openAiFileId"];
        }
    }

    static fromJS(data: any): DeleteGuidelineFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGuidelineFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openAiFileId"] = this.openAiFileId;
        return data;
    }
}

export interface IDeleteGuidelineFileRequest {
    openAiFileId?: string | undefined;
}

export class DeleteGuidelineFileResponse implements IDeleteGuidelineFileResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;

    constructor(data?: IDeleteGuidelineFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
        }
    }

    static fromJS(data: any): DeleteGuidelineFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGuidelineFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        return data;
    }
}

export interface IDeleteGuidelineFileResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
}

export class DirectLogMealRequest implements IDirectLogMealRequest {
    foodPhrase?: string | undefined;
    messageId?: string | undefined;
    localDateKey?: string | undefined;

    constructor(data?: IDirectLogMealRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.foodPhrase = _data["foodPhrase"];
            this.messageId = _data["messageId"];
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): DirectLogMealRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DirectLogMealRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foodPhrase"] = this.foodPhrase;
        data["messageId"] = this.messageId;
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface IDirectLogMealRequest {
    foodPhrase?: string | undefined;
    messageId?: string | undefined;
    localDateKey?: string | undefined;
}

export class DisconnectHealthConnectionRequest implements IDisconnectHealthConnectionRequest {
    installationId?: string | undefined;
    platform?: string | undefined;

    constructor(data?: IDisconnectHealthConnectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): DisconnectHealthConnectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisconnectHealthConnectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["platform"] = this.platform;
        return data;
    }
}

export interface IDisconnectHealthConnectionRequest {
    installationId?: string | undefined;
    platform?: string | undefined;
}

export class EditFoodSelectionRequest implements IEditFoodSelectionRequest {
    foodEntryId!: string;
    foodId?: string | undefined;
    componentId?: string | undefined;
    localDateKey?: string | undefined;
    isInlineEdit?: boolean;

    constructor(data?: IEditFoodSelectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.foodEntryId = _data["foodEntryId"];
            this.foodId = _data["foodId"];
            this.componentId = _data["componentId"];
            this.localDateKey = _data["localDateKey"];
            this.isInlineEdit = _data["isInlineEdit"];
        }
    }

    static fromJS(data: any): EditFoodSelectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditFoodSelectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foodEntryId"] = this.foodEntryId;
        data["foodId"] = this.foodId;
        data["componentId"] = this.componentId;
        data["localDateKey"] = this.localDateKey;
        data["isInlineEdit"] = this.isInlineEdit;
        return data;
    }
}

export interface IEditFoodSelectionRequest {
    foodEntryId: string;
    foodId?: string | undefined;
    componentId?: string | undefined;
    localDateKey?: string | undefined;
    isInlineEdit?: boolean;
}

export enum EnergyCoverageState {
    Complete = "Complete",
    CurrentDayPartial = "CurrentDayPartial",
    NoReadableData = "NoReadableData",
    Delayed = "Delayed",
    Unavailable = "Unavailable",
}

export enum EnergyTotalMethod {
    Unavailable = "Unavailable",
    HealthConnectAggregate = "HealthConnectAggregate",
    AppleActivePlusBasal = "AppleActivePlusBasal",
}

export class ErrorDto implements IErrorDto {
    errorMessage?: string | undefined;
    errorCode?: string | undefined;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IErrorDto {
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
}

export class FavoriteFoodDto implements IFavoriteFoodDto {
    id?: string | undefined;
    foodSnapshot?: Food;
    mealType?: MealType;
    timesLogged?: number;
    lastLoggedDateUtc?: Date;
    score?: number;

    constructor(data?: IFavoriteFoodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.foodSnapshot = _data["foodSnapshot"] ? Food.fromJS(_data["foodSnapshot"]) : <any>undefined;
            this.mealType = _data["mealType"];
            this.timesLogged = _data["timesLogged"];
            this.lastLoggedDateUtc = _data["lastLoggedDateUtc"] ? new Date(_data["lastLoggedDateUtc"].toString()) : <any>undefined;
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): FavoriteFoodDto {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteFoodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["foodSnapshot"] = this.foodSnapshot ? this.foodSnapshot.toJSON() : <any>undefined;
        data["mealType"] = this.mealType;
        data["timesLogged"] = this.timesLogged;
        data["lastLoggedDateUtc"] = this.lastLoggedDateUtc ? this.lastLoggedDateUtc.toISOString() : <any>undefined;
        data["score"] = this.score;
        return data;
    }
}

export interface IFavoriteFoodDto {
    id?: string | undefined;
    foodSnapshot?: Food;
    mealType?: MealType;
    timesLogged?: number;
    lastLoggedDateUtc?: Date;
    score?: number;
}

export class FeedbackEntry implements IFeedbackEntry {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    accountId?: string | undefined;
    feedbackType?: string | undefined;
    message?: string | undefined;
    clientContext?: TelemetryContext;
    serverContext?: TelemetryContext;
    isCompleted?: boolean;
    completedDateUtc?: Date | undefined;
    completionNote?: string | undefined;
    completedByAccountId?: string | undefined;
    isAssistantResponseShown?: boolean;
    assistantResponseShownDateUtc?: Date | undefined;
    localDateKey?: string | undefined;

    constructor(data?: IFeedbackEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.lastUpdatedDateUtc = _data["lastUpdatedDateUtc"] ? new Date(_data["lastUpdatedDateUtc"].toString()) : <any>undefined;
            this.accountId = _data["accountId"];
            this.feedbackType = _data["feedbackType"];
            this.message = _data["message"];
            this.clientContext = _data["clientContext"] ? TelemetryContext.fromJS(_data["clientContext"]) : <any>undefined;
            this.serverContext = _data["serverContext"] ? TelemetryContext.fromJS(_data["serverContext"]) : <any>undefined;
            this.isCompleted = _data["isCompleted"];
            this.completedDateUtc = _data["completedDateUtc"] ? new Date(_data["completedDateUtc"].toString()) : <any>undefined;
            this.completionNote = _data["completionNote"];
            this.completedByAccountId = _data["completedByAccountId"];
            this.isAssistantResponseShown = _data["isAssistantResponseShown"];
            this.assistantResponseShownDateUtc = _data["assistantResponseShownDateUtc"] ? new Date(_data["assistantResponseShownDateUtc"].toString()) : <any>undefined;
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): FeedbackEntry {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["lastUpdatedDateUtc"] = this.lastUpdatedDateUtc ? this.lastUpdatedDateUtc.toISOString() : <any>undefined;
        data["accountId"] = this.accountId;
        data["feedbackType"] = this.feedbackType;
        data["message"] = this.message;
        data["clientContext"] = this.clientContext ? this.clientContext.toJSON() : <any>undefined;
        data["serverContext"] = this.serverContext ? this.serverContext.toJSON() : <any>undefined;
        data["isCompleted"] = this.isCompleted;
        data["completedDateUtc"] = this.completedDateUtc ? this.completedDateUtc.toISOString() : <any>undefined;
        data["completionNote"] = this.completionNote;
        data["completedByAccountId"] = this.completedByAccountId;
        data["isAssistantResponseShown"] = this.isAssistantResponseShown;
        data["assistantResponseShownDateUtc"] = this.assistantResponseShownDateUtc ? this.assistantResponseShownDateUtc.toISOString() : <any>undefined;
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface IFeedbackEntry {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    accountId?: string | undefined;
    feedbackType?: string | undefined;
    message?: string | undefined;
    clientContext?: TelemetryContext;
    serverContext?: TelemetryContext;
    isCompleted?: boolean;
    completedDateUtc?: Date | undefined;
    completionNote?: string | undefined;
    completedByAccountId?: string | undefined;
    isAssistantResponseShown?: boolean;
    assistantResponseShownDateUtc?: Date | undefined;
    localDateKey?: string | undefined;
}

export class FeedbackWithAccount implements IFeedbackWithAccount {
    feedback?: FeedbackEntry;
    accountEmail?: string | undefined;
    accountId?: string | undefined;
    accountCreatedDate?: Date | undefined;

    constructor(data?: IFeedbackWithAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feedback = _data["feedback"] ? FeedbackEntry.fromJS(_data["feedback"]) : <any>undefined;
            this.accountEmail = _data["accountEmail"];
            this.accountId = _data["accountId"];
            this.accountCreatedDate = _data["accountCreatedDate"] ? new Date(_data["accountCreatedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FeedbackWithAccount {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackWithAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["accountEmail"] = this.accountEmail;
        data["accountId"] = this.accountId;
        data["accountCreatedDate"] = this.accountCreatedDate ? this.accountCreatedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFeedbackWithAccount {
    feedback?: FeedbackEntry;
    accountEmail?: string | undefined;
    accountId?: string | undefined;
    accountCreatedDate?: Date | undefined;
}

export class Food implements IFood {
    id?: string | undefined;
    name?: string | undefined;
    quantity?: number;
    singularUnit?: string | undefined;
    pluralUnit?: string | undefined;
    readonly measuredQuantity?: number | undefined;
    readonly measuredUnit?: string | undefined;
    description?: string | undefined;
    brand?: string | undefined;
    originalPhrase?: string | undefined;
    foodPictureDescription?: string | undefined;
    photoThumb?: string | undefined;
    photoHighRes?: string | undefined;
    components?: Component[] | undefined;
    isPending?: boolean;
    statusText?: string | undefined;

    constructor(data?: IFood) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.singularUnit = _data["singularUnit"];
            this.pluralUnit = _data["pluralUnit"];
            (<any>this).measuredQuantity = _data["measuredQuantity"];
            (<any>this).measuredUnit = _data["measuredUnit"];
            this.description = _data["description"];
            this.brand = _data["brand"];
            this.originalPhrase = _data["originalPhrase"];
            this.foodPictureDescription = _data["foodPictureDescription"];
            this.photoThumb = _data["photoThumb"];
            this.photoHighRes = _data["photoHighRes"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(Component.fromJS(item));
            }
            this.isPending = _data["isPending"];
            this.statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): Food {
        data = typeof data === 'object' ? data : {};
        let result = new Food();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["singularUnit"] = this.singularUnit;
        data["pluralUnit"] = this.pluralUnit;
        data["measuredQuantity"] = this.measuredQuantity;
        data["measuredUnit"] = this.measuredUnit;
        data["description"] = this.description;
        data["brand"] = this.brand;
        data["originalPhrase"] = this.originalPhrase;
        data["foodPictureDescription"] = this.foodPictureDescription;
        data["photoThumb"] = this.photoThumb;
        data["photoHighRes"] = this.photoHighRes;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        data["isPending"] = this.isPending;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IFood {
    id?: string | undefined;
    name?: string | undefined;
    quantity?: number;
    singularUnit?: string | undefined;
    pluralUnit?: string | undefined;
    measuredQuantity?: number | undefined;
    measuredUnit?: string | undefined;
    description?: string | undefined;
    brand?: string | undefined;
    originalPhrase?: string | undefined;
    foodPictureDescription?: string | undefined;
    photoThumb?: string | undefined;
    photoHighRes?: string | undefined;
    components?: Component[] | undefined;
    isPending?: boolean;
    statusText?: string | undefined;
}

export class FoodBreakdown implements IFoodBreakdown {
    foodItemIds?: string[] | undefined;
    foodEntryId?: string | undefined;
    foodId?: string | undefined;
    componentId?: string | undefined;
    name?: string | undefined;
    brandName?: string | undefined;
    quantity?: number;
    foodUnit?: string | undefined;
    measuredQuantity?: number | undefined;
    measuredUnit?: string | undefined;
    totalAmount?: number;
    unit?: string | undefined;
    nutrients?: NutrientContribution[] | undefined;
    components?: ComponentBreakdown[] | undefined;
    componentCount?: number;

    constructor(data?: IFoodBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["foodItemIds"])) {
                this.foodItemIds = [] as any;
                for (let item of _data["foodItemIds"])
                    this.foodItemIds!.push(item);
            }
            this.foodEntryId = _data["foodEntryId"];
            this.foodId = _data["foodId"];
            this.componentId = _data["componentId"];
            this.name = _data["name"];
            this.brandName = _data["brandName"];
            this.quantity = _data["quantity"];
            this.foodUnit = _data["foodUnit"];
            this.measuredQuantity = _data["measuredQuantity"];
            this.measuredUnit = _data["measuredUnit"];
            this.totalAmount = _data["totalAmount"];
            this.unit = _data["unit"];
            if (Array.isArray(_data["nutrients"])) {
                this.nutrients = [] as any;
                for (let item of _data["nutrients"])
                    this.nutrients!.push(NutrientContribution.fromJS(item));
            }
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ComponentBreakdown.fromJS(item));
            }
            this.componentCount = _data["componentCount"];
        }
    }

    static fromJS(data: any): FoodBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new FoodBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.foodItemIds)) {
            data["foodItemIds"] = [];
            for (let item of this.foodItemIds)
                data["foodItemIds"].push(item);
        }
        data["foodEntryId"] = this.foodEntryId;
        data["foodId"] = this.foodId;
        data["componentId"] = this.componentId;
        data["name"] = this.name;
        data["brandName"] = this.brandName;
        data["quantity"] = this.quantity;
        data["foodUnit"] = this.foodUnit;
        data["measuredQuantity"] = this.measuredQuantity;
        data["measuredUnit"] = this.measuredUnit;
        data["totalAmount"] = this.totalAmount;
        data["unit"] = this.unit;
        if (Array.isArray(this.nutrients)) {
            data["nutrients"] = [];
            for (let item of this.nutrients)
                data["nutrients"].push(item.toJSON());
        }
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        data["componentCount"] = this.componentCount;
        return data;
    }
}

export interface IFoodBreakdown {
    foodItemIds?: string[] | undefined;
    foodEntryId?: string | undefined;
    foodId?: string | undefined;
    componentId?: string | undefined;
    name?: string | undefined;
    brandName?: string | undefined;
    quantity?: number;
    foodUnit?: string | undefined;
    measuredQuantity?: number | undefined;
    measuredUnit?: string | undefined;
    totalAmount?: number;
    unit?: string | undefined;
    nutrients?: NutrientContribution[] | undefined;
    components?: ComponentBreakdown[] | undefined;
    componentCount?: number;
}

export class FoodContribution implements IFoodContribution {
    name?: string | undefined;
    brandName?: string | undefined;
    amount?: number;
    unit?: string | undefined;
    foodUnit?: string | undefined;
    displayQuantity?: number;
    foodEntryId?: string | undefined;
    foodId?: string | undefined;
    componentId?: string | undefined;

    constructor(data?: IFoodContribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.brandName = _data["brandName"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
            this.foodUnit = _data["foodUnit"];
            this.displayQuantity = _data["displayQuantity"];
            this.foodEntryId = _data["foodEntryId"];
            this.foodId = _data["foodId"];
            this.componentId = _data["componentId"];
        }
    }

    static fromJS(data: any): FoodContribution {
        data = typeof data === 'object' ? data : {};
        let result = new FoodContribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["brandName"] = this.brandName;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        data["foodUnit"] = this.foodUnit;
        data["displayQuantity"] = this.displayQuantity;
        data["foodEntryId"] = this.foodEntryId;
        data["foodId"] = this.foodId;
        data["componentId"] = this.componentId;
        return data;
    }
}

export interface IFoodContribution {
    name?: string | undefined;
    brandName?: string | undefined;
    amount?: number;
    unit?: string | undefined;
    foodUnit?: string | undefined;
    displayQuantity?: number;
    foodEntryId?: string | undefined;
    foodId?: string | undefined;
    componentId?: string | undefined;
}

export class FoodEntryBreakdown implements IFoodEntryBreakdown {
    foodEntryId?: string | undefined;
    entryName?: string | undefined;
    localDateKey?: string | undefined;
    createdDateUtc?: Date;
    foods?: FoodBreakdown[] | undefined;
    nutrients?: NutrientContribution[] | undefined;

    constructor(data?: IFoodEntryBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.foodEntryId = _data["foodEntryId"];
            this.entryName = _data["entryName"];
            this.localDateKey = _data["localDateKey"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            if (Array.isArray(_data["foods"])) {
                this.foods = [] as any;
                for (let item of _data["foods"])
                    this.foods!.push(FoodBreakdown.fromJS(item));
            }
            if (Array.isArray(_data["nutrients"])) {
                this.nutrients = [] as any;
                for (let item of _data["nutrients"])
                    this.nutrients!.push(NutrientContribution.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FoodEntryBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new FoodEntryBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foodEntryId"] = this.foodEntryId;
        data["entryName"] = this.entryName;
        data["localDateKey"] = this.localDateKey;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        if (Array.isArray(this.foods)) {
            data["foods"] = [];
            for (let item of this.foods)
                data["foods"].push(item.toJSON());
        }
        if (Array.isArray(this.nutrients)) {
            data["nutrients"] = [];
            for (let item of this.nutrients)
                data["nutrients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFoodEntryBreakdown {
    foodEntryId?: string | undefined;
    entryName?: string | undefined;
    localDateKey?: string | undefined;
    createdDateUtc?: Date;
    foods?: FoodBreakdown[] | undefined;
    nutrients?: NutrientContribution[] | undefined;
}

export class FoodPreview implements IFoodPreview {
    name?: string | undefined;
    componentNames?: string[] | undefined;

    constructor(data?: IFoodPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["componentNames"])) {
                this.componentNames = [] as any;
                for (let item of _data["componentNames"])
                    this.componentNames!.push(item);
            }
        }
    }

    static fromJS(data: any): FoodPreview {
        data = typeof data === 'object' ? data : {};
        let result = new FoodPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.componentNames)) {
            data["componentNames"] = [];
            for (let item of this.componentNames)
                data["componentNames"].push(item);
        }
        return data;
    }
}

export interface IFoodPreview {
    name?: string | undefined;
    componentNames?: string[] | undefined;
}

export class GetAccountDataCountsRequest implements IGetAccountDataCountsRequest {
    accountId?: string | undefined;

    constructor(data?: IGetAccountDataCountsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): GetAccountDataCountsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountDataCountsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IGetAccountDataCountsRequest {
    accountId?: string | undefined;
}

export class GetAccountDataCountsResponse implements IGetAccountDataCountsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accountId?: string | undefined;
    dataCounts?: { [key: string]: number; } | undefined;
    totalDataCount?: number;

    constructor(data?: IGetAccountDataCountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.accountId = _data["accountId"];
            if (_data["dataCounts"]) {
                this.dataCounts = {} as any;
                for (let key in _data["dataCounts"]) {
                    if (_data["dataCounts"].hasOwnProperty(key))
                        (<any>this.dataCounts)![key] = _data["dataCounts"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
        }
    }

    static fromJS(data: any): GetAccountDataCountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountDataCountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["accountId"] = this.accountId;
        if (this.dataCounts) {
            data["dataCounts"] = {};
            for (let key in this.dataCounts) {
                if (this.dataCounts.hasOwnProperty(key))
                    (<any>data["dataCounts"])[key] = (<any>this.dataCounts)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        return data;
    }
}

export interface IGetAccountDataCountsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accountId?: string | undefined;
    dataCounts?: { [key: string]: number; } | undefined;
    totalDataCount?: number;
}

export class GetAllAccountsRequest implements IGetAllAccountsRequest {
    searchFilter?: string | undefined;
    accountTypeFilter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    page?: number;
    pageSize?: number;
    includeDeleted?: boolean;
    hasLoggedFirstMealFilter?: boolean | undefined;

    constructor(data?: IGetAllAccountsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFilter = _data["searchFilter"];
            this.accountTypeFilter = _data["accountTypeFilter"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.includeDeleted = _data["includeDeleted"];
            this.hasLoggedFirstMealFilter = _data["hasLoggedFirstMealFilter"];
        }
    }

    static fromJS(data: any): GetAllAccountsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAccountsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFilter"] = this.searchFilter;
        data["accountTypeFilter"] = this.accountTypeFilter;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["includeDeleted"] = this.includeDeleted;
        data["hasLoggedFirstMealFilter"] = this.hasLoggedFirstMealFilter;
        return data;
    }
}

export interface IGetAllAccountsRequest {
    searchFilter?: string | undefined;
    accountTypeFilter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    page?: number;
    pageSize?: number;
    includeDeleted?: boolean;
    hasLoggedFirstMealFilter?: boolean | undefined;
}

export class GetAllAccountsResponse implements IGetAllAccountsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accounts?: Account[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetAllAccountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(Account.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): GetAllAccountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAccountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IGetAllAccountsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accounts?: Account[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
}

export class GetChatMessagesRequest implements IGetChatMessagesRequest {
    localDateKey!: string;

    constructor(data?: IGetChatMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): GetChatMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetChatMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface IGetChatMessagesRequest {
    localDateKey: string;
}

export class GetDetailedSummaryRequest implements IGetDetailedSummaryRequest {
    localDateKey?: string | undefined;

    constructor(data?: IGetDetailedSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): GetDetailedSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDetailedSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface IGetDetailedSummaryRequest {
    localDateKey?: string | undefined;
}

export class GetDetailedSummaryResponse implements IGetDetailedSummaryResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    dailySummary?: DailySummary;

    constructor(data?: IGetDetailedSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.dailySummary = _data["dailySummary"] ? DailySummary.fromJS(_data["dailySummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDetailedSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDetailedSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["dailySummary"] = this.dailySummary ? this.dailySummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDetailedSummaryResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    dailySummary?: DailySummary;
}

export class GetFavoritesRequest implements IGetFavoritesRequest {

    constructor(data?: IGetFavoritesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetFavoritesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFavoritesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetFavoritesRequest {
}

export class GetFavoritesResponse implements IGetFavoritesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    favorites?: FavoriteFoodDto[] | undefined;

    constructor(data?: IGetFavoritesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            if (Array.isArray(_data["favorites"])) {
                this.favorites = [] as any;
                for (let item of _data["favorites"])
                    this.favorites!.push(FavoriteFoodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFavoritesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFavoritesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        if (Array.isArray(this.favorites)) {
            data["favorites"] = [];
            for (let item of this.favorites)
                data["favorites"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFavoritesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    favorites?: FavoriteFoodDto[] | undefined;
}

export class GetFeedbackResponse implements IGetFeedbackResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    feedbackEntries?: FeedbackEntry[] | undefined;
    feedbackEntry?: FeedbackEntry;
    feedbackWithAccounts?: FeedbackWithAccount[] | undefined;

    constructor(data?: IGetFeedbackResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            if (Array.isArray(_data["feedbackEntries"])) {
                this.feedbackEntries = [] as any;
                for (let item of _data["feedbackEntries"])
                    this.feedbackEntries!.push(FeedbackEntry.fromJS(item));
            }
            this.feedbackEntry = _data["feedbackEntry"] ? FeedbackEntry.fromJS(_data["feedbackEntry"]) : <any>undefined;
            if (Array.isArray(_data["feedbackWithAccounts"])) {
                this.feedbackWithAccounts = [] as any;
                for (let item of _data["feedbackWithAccounts"])
                    this.feedbackWithAccounts!.push(FeedbackWithAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFeedbackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        if (Array.isArray(this.feedbackEntries)) {
            data["feedbackEntries"] = [];
            for (let item of this.feedbackEntries)
                data["feedbackEntries"].push(item.toJSON());
        }
        data["feedbackEntry"] = this.feedbackEntry ? this.feedbackEntry.toJSON() : <any>undefined;
        if (Array.isArray(this.feedbackWithAccounts)) {
            data["feedbackWithAccounts"] = [];
            for (let item of this.feedbackWithAccounts)
                data["feedbackWithAccounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFeedbackResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    feedbackEntries?: FeedbackEntry[] | undefined;
    feedbackEntry?: FeedbackEntry;
    feedbackWithAccounts?: FeedbackWithAccount[] | undefined;
}

export class GetFeedbackWithAccountInfoRequest implements IGetFeedbackWithAccountInfoRequest {
    feedbackType?: string | undefined;
    accountId?: string | undefined;
    completedOnly?: boolean;
    incompleteOnly?: boolean;
    accountEmail?: string | undefined;

    constructor(data?: IGetFeedbackWithAccountInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feedbackType = _data["feedbackType"];
            this.accountId = _data["accountId"];
            this.completedOnly = _data["completedOnly"];
            this.incompleteOnly = _data["incompleteOnly"];
            this.accountEmail = _data["accountEmail"];
        }
    }

    static fromJS(data: any): GetFeedbackWithAccountInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackWithAccountInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedbackType"] = this.feedbackType;
        data["accountId"] = this.accountId;
        data["completedOnly"] = this.completedOnly;
        data["incompleteOnly"] = this.incompleteOnly;
        data["accountEmail"] = this.accountEmail;
        return data;
    }
}

export interface IGetFeedbackWithAccountInfoRequest {
    feedbackType?: string | undefined;
    accountId?: string | undefined;
    completedOnly?: boolean;
    incompleteOnly?: boolean;
    accountEmail?: string | undefined;
}

export class GetFeedbackWithAccountInfoResponse implements IGetFeedbackWithAccountInfoResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    feedbackWithAccounts?: FeedbackWithAccount[] | undefined;

    constructor(data?: IGetFeedbackWithAccountInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            if (Array.isArray(_data["feedbackWithAccounts"])) {
                this.feedbackWithAccounts = [] as any;
                for (let item of _data["feedbackWithAccounts"])
                    this.feedbackWithAccounts!.push(FeedbackWithAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFeedbackWithAccountInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackWithAccountInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        if (Array.isArray(this.feedbackWithAccounts)) {
            data["feedbackWithAccounts"] = [];
            for (let item of this.feedbackWithAccounts)
                data["feedbackWithAccounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFeedbackWithAccountInfoResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    feedbackWithAccounts?: FeedbackWithAccount[] | undefined;
}

export class GetGuidelineFileUploadUrlRequest implements IGetGuidelineFileUploadUrlRequest {
    fileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IGetGuidelineFileUploadUrlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): GetGuidelineFileUploadUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGuidelineFileUploadUrlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IGetGuidelineFileUploadUrlRequest {
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export class GetGuidelineFileUploadUrlResponse implements IGetGuidelineFileUploadUrlResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    signedUrl?: string | undefined;
    objectName?: string | undefined;
    expiresAt?: Date | undefined;

    constructor(data?: IGetGuidelineFileUploadUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.signedUrl = _data["signedUrl"];
            this.objectName = _data["objectName"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGuidelineFileUploadUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGuidelineFileUploadUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["signedUrl"] = this.signedUrl;
        data["objectName"] = this.objectName;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetGuidelineFileUploadUrlResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    signedUrl?: string | undefined;
    objectName?: string | undefined;
    expiresAt?: Date | undefined;
}

export class GetGuidelineFileViewUrlRequest implements IGetGuidelineFileViewUrlRequest {
    openAiFileId?: string | undefined;
    objectName?: string | undefined;

    constructor(data?: IGetGuidelineFileViewUrlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openAiFileId = _data["openAiFileId"];
            this.objectName = _data["objectName"];
        }
    }

    static fromJS(data: any): GetGuidelineFileViewUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGuidelineFileViewUrlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openAiFileId"] = this.openAiFileId;
        data["objectName"] = this.objectName;
        return data;
    }
}

export interface IGetGuidelineFileViewUrlRequest {
    openAiFileId?: string | undefined;
    objectName?: string | undefined;
}

export class GetGuidelineFileViewUrlResponse implements IGetGuidelineFileViewUrlResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    signedUrl?: string | undefined;
    expiresAt?: Date | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IGetGuidelineFileViewUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.signedUrl = _data["signedUrl"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): GetGuidelineFileViewUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGuidelineFileViewUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["signedUrl"] = this.signedUrl;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IGetGuidelineFileViewUrlResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    signedUrl?: string | undefined;
    expiresAt?: Date | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export class GetGuidelineFilesRequest implements IGetGuidelineFilesRequest {

    constructor(data?: IGetGuidelineFilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGuidelineFilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGuidelineFilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGuidelineFilesRequest {
}

export class GetGuidelineFilesResponse implements IGetGuidelineFilesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    files?: OpenAiFile[] | undefined;

    constructor(data?: IGetGuidelineFilesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(OpenAiFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGuidelineFilesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGuidelineFilesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGuidelineFilesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    files?: OpenAiFile[] | undefined;
}

export class GetInstantAlternativesRequest implements IGetInstantAlternativesRequest {
    originalPhrase!: string;
    componentId?: string | undefined;
    localDateKey!: string;

    constructor(data?: IGetInstantAlternativesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalPhrase = _data["originalPhrase"];
            this.componentId = _data["componentId"];
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): GetInstantAlternativesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetInstantAlternativesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalPhrase"] = this.originalPhrase;
        data["componentId"] = this.componentId;
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface IGetInstantAlternativesRequest {
    originalPhrase: string;
    componentId?: string | undefined;
    localDateKey: string;
}

export class GetInstantAlternativesResponse implements IGetInstantAlternativesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    originalPhrase?: string | undefined;
    componentId?: string | undefined;
    alternatives?: ComponentMatch[] | undefined;
    searchMethod?: string | undefined;

    constructor(data?: IGetInstantAlternativesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.originalPhrase = _data["originalPhrase"];
            this.componentId = _data["componentId"];
            if (Array.isArray(_data["alternatives"])) {
                this.alternatives = [] as any;
                for (let item of _data["alternatives"])
                    this.alternatives!.push(ComponentMatch.fromJS(item));
            }
            this.searchMethod = _data["searchMethod"];
        }
    }

    static fromJS(data: any): GetInstantAlternativesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInstantAlternativesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["originalPhrase"] = this.originalPhrase;
        data["componentId"] = this.componentId;
        if (Array.isArray(this.alternatives)) {
            data["alternatives"] = [];
            for (let item of this.alternatives)
                data["alternatives"].push(item.toJSON());
        }
        data["searchMethod"] = this.searchMethod;
        return data;
    }
}

export interface IGetInstantAlternativesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    originalPhrase?: string | undefined;
    componentId?: string | undefined;
    alternatives?: ComponentMatch[] | undefined;
    searchMethod?: string | undefined;
}

export class GetNotifiableAccountsRequest implements IGetNotifiableAccountsRequest {
    noMealWithinHours?: number | undefined;
    noChatWithinHours?: number | undefined;
    expiredGuestNotConverted?: boolean | undefined;
    expiredTrialNotConverted?: boolean | undefined;
    searchFilter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    page?: number;
    pageSize?: number;

    constructor(data?: IGetNotifiableAccountsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noMealWithinHours = _data["noMealWithinHours"];
            this.noChatWithinHours = _data["noChatWithinHours"];
            this.expiredGuestNotConverted = _data["expiredGuestNotConverted"];
            this.expiredTrialNotConverted = _data["expiredTrialNotConverted"];
            this.searchFilter = _data["searchFilter"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetNotifiableAccountsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotifiableAccountsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noMealWithinHours"] = this.noMealWithinHours;
        data["noChatWithinHours"] = this.noChatWithinHours;
        data["expiredGuestNotConverted"] = this.expiredGuestNotConverted;
        data["expiredTrialNotConverted"] = this.expiredTrialNotConverted;
        data["searchFilter"] = this.searchFilter;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetNotifiableAccountsRequest {
    noMealWithinHours?: number | undefined;
    noChatWithinHours?: number | undefined;
    expiredGuestNotConverted?: boolean | undefined;
    expiredTrialNotConverted?: boolean | undefined;
    searchFilter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    page?: number;
    pageSize?: number;
}

export class GetNotifiableAccountsResponse implements IGetNotifiableAccountsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accounts?: NotifiableAccountDto[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetNotifiableAccountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(NotifiableAccountDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): GetNotifiableAccountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotifiableAccountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IGetNotifiableAccountsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accounts?: NotifiableAccountDto[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
}

export class GetProfileAndTargetsRequest implements IGetProfileAndTargetsRequest {
    localDateKey?: string | undefined;

    constructor(data?: IGetProfileAndTargetsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): GetProfileAndTargetsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfileAndTargetsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface IGetProfileAndTargetsRequest {
    localDateKey?: string | undefined;
}

export class GetProfileAndTargetsResponse implements IGetProfileAndTargetsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    age?: number | undefined;
    sex?: string | undefined;
    heightFeet?: number | undefined;
    heightInches?: number | undefined;
    weightLbs?: number | undefined;
    activityLevel?: string | undefined;
    baseCalories?: number | undefined;
    hasTargets?: boolean;
    isOverride?: boolean;
    baselineCalories?: number | undefined;
    goals?: string[] | undefined;
    goalSummary?: string | undefined;
    nutrientTargets?: NutrientTarget[] | undefined;
    baselineNutrientTargets?: NutrientTarget[] | undefined;

    constructor(data?: IGetProfileAndTargetsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.age = _data["age"];
            this.sex = _data["sex"];
            this.heightFeet = _data["heightFeet"];
            this.heightInches = _data["heightInches"];
            this.weightLbs = _data["weightLbs"];
            this.activityLevel = _data["activityLevel"];
            this.baseCalories = _data["baseCalories"];
            this.hasTargets = _data["hasTargets"];
            this.isOverride = _data["isOverride"];
            this.baselineCalories = _data["baselineCalories"];
            if (Array.isArray(_data["goals"])) {
                this.goals = [] as any;
                for (let item of _data["goals"])
                    this.goals!.push(item);
            }
            this.goalSummary = _data["goalSummary"];
            if (Array.isArray(_data["nutrientTargets"])) {
                this.nutrientTargets = [] as any;
                for (let item of _data["nutrientTargets"])
                    this.nutrientTargets!.push(NutrientTarget.fromJS(item));
            }
            if (Array.isArray(_data["baselineNutrientTargets"])) {
                this.baselineNutrientTargets = [] as any;
                for (let item of _data["baselineNutrientTargets"])
                    this.baselineNutrientTargets!.push(NutrientTarget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProfileAndTargetsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfileAndTargetsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["age"] = this.age;
        data["sex"] = this.sex;
        data["heightFeet"] = this.heightFeet;
        data["heightInches"] = this.heightInches;
        data["weightLbs"] = this.weightLbs;
        data["activityLevel"] = this.activityLevel;
        data["baseCalories"] = this.baseCalories;
        data["hasTargets"] = this.hasTargets;
        data["isOverride"] = this.isOverride;
        data["baselineCalories"] = this.baselineCalories;
        if (Array.isArray(this.goals)) {
            data["goals"] = [];
            for (let item of this.goals)
                data["goals"].push(item);
        }
        data["goalSummary"] = this.goalSummary;
        if (Array.isArray(this.nutrientTargets)) {
            data["nutrientTargets"] = [];
            for (let item of this.nutrientTargets)
                data["nutrientTargets"].push(item.toJSON());
        }
        if (Array.isArray(this.baselineNutrientTargets)) {
            data["baselineNutrientTargets"] = [];
            for (let item of this.baselineNutrientTargets)
                data["baselineNutrientTargets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProfileAndTargetsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    age?: number | undefined;
    sex?: string | undefined;
    heightFeet?: number | undefined;
    heightInches?: number | undefined;
    weightLbs?: number | undefined;
    activityLevel?: string | undefined;
    baseCalories?: number | undefined;
    hasTargets?: boolean;
    isOverride?: boolean;
    baselineCalories?: number | undefined;
    goals?: string[] | undefined;
    goalSummary?: string | undefined;
    nutrientTargets?: NutrientTarget[] | undefined;
    baselineNutrientTargets?: NutrientTarget[] | undefined;
}

export class GetSharedMealRequest implements IGetSharedMealRequest {
    shareToken?: string | undefined;
    localDateKey?: string | undefined;

    constructor(data?: IGetSharedMealRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shareToken = _data["shareToken"];
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): GetSharedMealRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedMealRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shareToken"] = this.shareToken;
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface IGetSharedMealRequest {
    shareToken?: string | undefined;
    localDateKey?: string | undefined;
}

export class GetSharedMealResponse implements IGetSharedMealResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    mealData?: MealSelection;
    sharedByAccountId?: string | undefined;
    isExpired?: boolean;

    constructor(data?: IGetSharedMealResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.mealData = _data["mealData"] ? MealSelection.fromJS(_data["mealData"]) : <any>undefined;
            this.sharedByAccountId = _data["sharedByAccountId"];
            this.isExpired = _data["isExpired"];
        }
    }

    static fromJS(data: any): GetSharedMealResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedMealResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["mealData"] = this.mealData ? this.mealData.toJSON() : <any>undefined;
        data["sharedByAccountId"] = this.sharedByAccountId;
        data["isExpired"] = this.isExpired;
        return data;
    }
}

export interface IGetSharedMealResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    mealData?: MealSelection;
    sharedByAccountId?: string | undefined;
    isExpired?: boolean;
}

export class GetUserChatMessagesRequest implements IGetUserChatMessagesRequest {
    accountId?: string | undefined;
    localDateKey?: string | undefined;
    limit?: number | undefined;

    constructor(data?: IGetUserChatMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.localDateKey = _data["localDateKey"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): GetUserChatMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["localDateKey"] = this.localDateKey;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IGetUserChatMessagesRequest {
    accountId?: string | undefined;
    localDateKey?: string | undefined;
    limit?: number | undefined;
}

export class GetUserChatMessagesResponse implements IGetUserChatMessagesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    messages?: ChatMessage[] | undefined;
    accountId?: string | undefined;
    accountEmail?: string | undefined;

    constructor(data?: IGetUserChatMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ChatMessage.fromJS(item));
            }
            this.accountId = _data["accountId"];
            this.accountEmail = _data["accountEmail"];
        }
    }

    static fromJS(data: any): GetUserChatMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["accountId"] = this.accountId;
        data["accountEmail"] = this.accountEmail;
        return data;
    }
}

export interface IGetUserChatMessagesResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    messages?: ChatMessage[] | undefined;
    accountId?: string | undefined;
    accountEmail?: string | undefined;
}

export class HealthHistoryProgressResponse implements IHealthHistoryProgressResponse {
    state?: string | undefined;
    scope?: string | undefined;
    inboundCursor?: string | undefined;
    outboundCursor?: string | undefined;
    inboundCompletedBatches?: number;
    outboundCompletedBatches?: number;
    lastErrorCategory?: string | undefined;

    constructor(data?: IHealthHistoryProgressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.scope = _data["scope"];
            this.inboundCursor = _data["inboundCursor"];
            this.outboundCursor = _data["outboundCursor"];
            this.inboundCompletedBatches = _data["inboundCompletedBatches"];
            this.outboundCompletedBatches = _data["outboundCompletedBatches"];
            this.lastErrorCategory = _data["lastErrorCategory"];
        }
    }

    static fromJS(data: any): HealthHistoryProgressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthHistoryProgressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["scope"] = this.scope;
        data["inboundCursor"] = this.inboundCursor;
        data["outboundCursor"] = this.outboundCursor;
        data["inboundCompletedBatches"] = this.inboundCompletedBatches;
        data["outboundCompletedBatches"] = this.outboundCompletedBatches;
        data["lastErrorCategory"] = this.lastErrorCategory;
        return data;
    }
}

export interface IHealthHistoryProgressResponse {
    state?: string | undefined;
    scope?: string | undefined;
    inboundCursor?: string | undefined;
    outboundCursor?: string | undefined;
    inboundCompletedBatches?: number;
    outboundCompletedBatches?: number;
    lastErrorCategory?: string | undefined;
}

export class HealthHistoryRunRequest implements IHealthHistoryRunRequest {
    installationId?: string | undefined;
    platform?: string | undefined;

    constructor(data?: IHealthHistoryRunRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): HealthHistoryRunRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthHistoryRunRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["platform"] = this.platform;
        return data;
    }
}

export interface IHealthHistoryRunRequest {
    installationId?: string | undefined;
    platform?: string | undefined;
}

export class HydrateAlternateSelectionRequest implements IHydrateAlternateSelectionRequest {
    componentId!: string;
    selectedMatch!: ComponentMatch;
    localDateKey!: string;
    messageId?: string | undefined;
    foodEntryId?: string | undefined;

    constructor(data?: IHydrateAlternateSelectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedMatch = new ComponentMatch();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.selectedMatch = _data["selectedMatch"] ? ComponentMatch.fromJS(_data["selectedMatch"]) : new ComponentMatch();
            this.localDateKey = _data["localDateKey"];
            this.messageId = _data["messageId"];
            this.foodEntryId = _data["foodEntryId"];
        }
    }

    static fromJS(data: any): HydrateAlternateSelectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HydrateAlternateSelectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["selectedMatch"] = this.selectedMatch ? this.selectedMatch.toJSON() : <any>undefined;
        data["localDateKey"] = this.localDateKey;
        data["messageId"] = this.messageId;
        data["foodEntryId"] = this.foodEntryId;
        return data;
    }
}

export interface IHydrateAlternateSelectionRequest {
    componentId: string;
    selectedMatch: ComponentMatch;
    localDateKey: string;
    messageId?: string | undefined;
    foodEntryId?: string | undefined;
}

export class InboundConnectionResponse implements IInboundConnectionResponse {
    connectionId?: string | undefined;
    activated?: boolean;
    window?: string | undefined;
    activeInboundPlatform?: string | undefined;

    constructor(data?: IInboundConnectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionId = _data["connectionId"];
            this.activated = _data["activated"];
            this.window = _data["window"];
            this.activeInboundPlatform = _data["activeInboundPlatform"];
        }
    }

    static fromJS(data: any): InboundConnectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InboundConnectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionId"] = this.connectionId;
        data["activated"] = this.activated;
        data["window"] = this.window;
        data["activeInboundPlatform"] = this.activeInboundPlatform;
        return data;
    }
}

export interface IInboundConnectionResponse {
    connectionId?: string | undefined;
    activated?: boolean;
    window?: string | undefined;
    activeInboundPlatform?: string | undefined;
}

export enum KnowledgeLevel {
    Beginner = "Beginner",
    Intermediate = "Intermediate",
    Advanced = "Advanced",
}

export class LearnMoreAboutRequest implements ILearnMoreAboutRequest {
    topic?: string | undefined;
    localDateKey?: string | undefined;

    constructor(data?: ILearnMoreAboutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"];
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): LearnMoreAboutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LearnMoreAboutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic;
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface ILearnMoreAboutRequest {
    topic?: string | undefined;
    localDateKey?: string | undefined;
}

export class LogEntryDto implements ILogEntryDto {
    timestampUtc?: Date;
    severity?: string | undefined;
    message?: string | undefined;
    accountId?: string | undefined;
    email?: string | undefined;
    traceId?: string | undefined;
    sourceService?: string | undefined;
    extra?: { [key: string]: string; } | undefined;

    constructor(data?: ILogEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestampUtc = _data["timestampUtc"] ? new Date(_data["timestampUtc"].toString()) : <any>undefined;
            this.severity = _data["severity"];
            this.message = _data["message"];
            this.accountId = _data["accountId"];
            this.email = _data["email"];
            this.traceId = _data["traceId"];
            this.sourceService = _data["sourceService"];
            if (_data["extra"]) {
                this.extra = {} as any;
                for (let key in _data["extra"]) {
                    if (_data["extra"].hasOwnProperty(key))
                        (<any>this.extra)![key] = _data["extra"][key];
                }
            }
        }
    }

    static fromJS(data: any): LogEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestampUtc"] = this.timestampUtc ? this.timestampUtc.toISOString() : <any>undefined;
        data["severity"] = this.severity;
        data["message"] = this.message;
        data["accountId"] = this.accountId;
        data["email"] = this.email;
        data["traceId"] = this.traceId;
        data["sourceService"] = this.sourceService;
        if (this.extra) {
            data["extra"] = {};
            for (let key in this.extra) {
                if (this.extra.hasOwnProperty(key))
                    (<any>data["extra"])[key] = (<any>this.extra)[key];
            }
        }
        return data;
    }
}

export interface ILogEntryDto {
    timestampUtc?: Date;
    severity?: string | undefined;
    message?: string | undefined;
    accountId?: string | undefined;
    email?: string | undefined;
    traceId?: string | undefined;
    sourceService?: string | undefined;
    extra?: { [key: string]: string; } | undefined;
}

export class MarkFeedbackAsShownRequest implements IMarkFeedbackAsShownRequest {
    feedbackIds?: string[] | undefined;

    constructor(data?: IMarkFeedbackAsShownRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["feedbackIds"])) {
                this.feedbackIds = [] as any;
                for (let item of _data["feedbackIds"])
                    this.feedbackIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MarkFeedbackAsShownRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkFeedbackAsShownRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.feedbackIds)) {
            data["feedbackIds"] = [];
            for (let item of this.feedbackIds)
                data["feedbackIds"].push(item);
        }
        return data;
    }
}

export interface IMarkFeedbackAsShownRequest {
    feedbackIds?: string[] | undefined;
}

export class MealPreview implements IMealPreview {
    mealName?: string | undefined;
    foods?: FoodPreview[] | undefined;

    constructor(data?: IMealPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mealName = _data["mealName"];
            if (Array.isArray(_data["foods"])) {
                this.foods = [] as any;
                for (let item of _data["foods"])
                    this.foods!.push(FoodPreview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MealPreview {
        data = typeof data === 'object' ? data : {};
        let result = new MealPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mealName"] = this.mealName;
        if (Array.isArray(this.foods)) {
            data["foods"] = [];
            for (let item of this.foods)
                data["foods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMealPreview {
    mealName?: string | undefined;
    foods?: FoodPreview[] | undefined;
}

export class MealSelection implements IMealSelection {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    accountId?: string | undefined;
    pendingMessageId?: string | undefined;
    mealName?: string | undefined;
    localDateKey?: string | undefined;
    foods?: Food[] | undefined;
    isConfirmed?: boolean;
    foodEntryId?: string | undefined;
    sharedById?: string | undefined;
    readonly isPending?: boolean;
    foodId?: string | undefined;
    componentId?: string | undefined;

    constructor(data?: IMealSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.lastUpdatedDateUtc = _data["lastUpdatedDateUtc"] ? new Date(_data["lastUpdatedDateUtc"].toString()) : <any>undefined;
            this.accountId = _data["accountId"];
            this.pendingMessageId = _data["pendingMessageId"];
            this.mealName = _data["mealName"];
            this.localDateKey = _data["localDateKey"];
            if (Array.isArray(_data["foods"])) {
                this.foods = [] as any;
                for (let item of _data["foods"])
                    this.foods!.push(Food.fromJS(item));
            }
            this.isConfirmed = _data["isConfirmed"];
            this.foodEntryId = _data["foodEntryId"];
            this.sharedById = _data["sharedById"];
            (<any>this).isPending = _data["isPending"];
            this.foodId = _data["foodId"];
            this.componentId = _data["componentId"];
        }
    }

    static fromJS(data: any): MealSelection {
        data = typeof data === 'object' ? data : {};
        let result = new MealSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["lastUpdatedDateUtc"] = this.lastUpdatedDateUtc ? this.lastUpdatedDateUtc.toISOString() : <any>undefined;
        data["accountId"] = this.accountId;
        data["pendingMessageId"] = this.pendingMessageId;
        data["mealName"] = this.mealName;
        data["localDateKey"] = this.localDateKey;
        if (Array.isArray(this.foods)) {
            data["foods"] = [];
            for (let item of this.foods)
                data["foods"].push(item.toJSON());
        }
        data["isConfirmed"] = this.isConfirmed;
        data["foodEntryId"] = this.foodEntryId;
        data["sharedById"] = this.sharedById;
        data["isPending"] = this.isPending;
        data["foodId"] = this.foodId;
        data["componentId"] = this.componentId;
        return data;
    }
}

export interface IMealSelection {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    accountId?: string | undefined;
    pendingMessageId?: string | undefined;
    mealName?: string | undefined;
    localDateKey?: string | undefined;
    foods?: Food[] | undefined;
    isConfirmed?: boolean;
    foodEntryId?: string | undefined;
    sharedById?: string | undefined;
    isPending?: boolean;
    foodId?: string | undefined;
    componentId?: string | undefined;
}

export enum MealType {
    Unknown = "Unknown",
    Breakfast = "Breakfast",
    Lunch = "Lunch",
    Dinner = "Dinner",
    Snack = "Snack",
}

export enum MessageRoleTypes {
    User = "User",
    Assistant = "Assistant",
    Tool = "Tool",
    System = "System",
    ContextNote = "ContextNote",
    PendingFoodSelection = "PendingFoodSelection",
    CompletedFoodSelection = "CompletedFoodSelection",
    CanceledFoodSelection = "CanceledFoodSelection",
    PendingEditFoodSelection = "PendingEditFoodSelection",
    CompletedEditFoodSelection = "CompletedEditFoodSelection",
}

export class NotifiableAccountDto implements INotifiableAccountDto {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    createdDateUtc?: Date;
    isAnonymousUser?: boolean;
    trialEndDateUtc?: Date | undefined;
    isPremium?: boolean;
    isPremiumLifetime?: boolean;
    deviceCount?: number;
    lastMealLoggedUtc?: Date | undefined;
    lastChatActivityUtc?: Date | undefined;
    accountStatus?: string | undefined;

    constructor(data?: INotifiableAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.isAnonymousUser = _data["isAnonymousUser"];
            this.trialEndDateUtc = _data["trialEndDateUtc"] ? new Date(_data["trialEndDateUtc"].toString()) : <any>undefined;
            this.isPremium = _data["isPremium"];
            this.isPremiumLifetime = _data["isPremiumLifetime"];
            this.deviceCount = _data["deviceCount"];
            this.lastMealLoggedUtc = _data["lastMealLoggedUtc"] ? new Date(_data["lastMealLoggedUtc"].toString()) : <any>undefined;
            this.lastChatActivityUtc = _data["lastChatActivityUtc"] ? new Date(_data["lastChatActivityUtc"].toString()) : <any>undefined;
            this.accountStatus = _data["accountStatus"];
        }
    }

    static fromJS(data: any): NotifiableAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotifiableAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["isAnonymousUser"] = this.isAnonymousUser;
        data["trialEndDateUtc"] = this.trialEndDateUtc ? this.trialEndDateUtc.toISOString() : <any>undefined;
        data["isPremium"] = this.isPremium;
        data["isPremiumLifetime"] = this.isPremiumLifetime;
        data["deviceCount"] = this.deviceCount;
        data["lastMealLoggedUtc"] = this.lastMealLoggedUtc ? this.lastMealLoggedUtc.toISOString() : <any>undefined;
        data["lastChatActivityUtc"] = this.lastChatActivityUtc ? this.lastChatActivityUtc.toISOString() : <any>undefined;
        data["accountStatus"] = this.accountStatus;
        return data;
    }
}

export interface INotifiableAccountDto {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    createdDateUtc?: Date;
    isAnonymousUser?: boolean;
    trialEndDateUtc?: Date | undefined;
    isPremium?: boolean;
    isPremiumLifetime?: boolean;
    deviceCount?: number;
    lastMealLoggedUtc?: Date | undefined;
    lastChatActivityUtc?: Date | undefined;
    accountStatus?: string | undefined;
}

export class NotificationActionRequest implements INotificationActionRequest {
    data?: { [key: string]: string; } | undefined;
    appIsActive?: boolean;

    constructor(data?: INotificationActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.appIsActive = _data["appIsActive"];
        }
    }

    static fromJS(data: any): NotificationActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["appIsActive"] = this.appIsActive;
        return data;
    }
}

export interface INotificationActionRequest {
    data?: { [key: string]: string; } | undefined;
    appIsActive?: boolean;
}

export class NutrientBreakdown implements INutrientBreakdown {
    nutrientKey?: string | undefined;
    nutrientName?: string | undefined;
    unit?: string | undefined;
    totalAmount?: number;
    targetValue?: number | undefined;
    minTarget?: number | undefined;
    maxTarget?: number | undefined;
    isGoal?: boolean;
    sortOrder?: number;
    readonly percentOfTarget?: number | undefined;
    foods?: FoodContribution[] | undefined;

    constructor(data?: INutrientBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nutrientKey = _data["nutrientKey"];
            this.nutrientName = _data["nutrientName"];
            this.unit = _data["unit"];
            this.totalAmount = _data["totalAmount"];
            this.targetValue = _data["targetValue"];
            this.minTarget = _data["minTarget"];
            this.maxTarget = _data["maxTarget"];
            this.isGoal = _data["isGoal"];
            this.sortOrder = _data["sortOrder"];
            (<any>this).percentOfTarget = _data["percentOfTarget"];
            if (Array.isArray(_data["foods"])) {
                this.foods = [] as any;
                for (let item of _data["foods"])
                    this.foods!.push(FoodContribution.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NutrientBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nutrientKey"] = this.nutrientKey;
        data["nutrientName"] = this.nutrientName;
        data["unit"] = this.unit;
        data["totalAmount"] = this.totalAmount;
        data["targetValue"] = this.targetValue;
        data["minTarget"] = this.minTarget;
        data["maxTarget"] = this.maxTarget;
        data["isGoal"] = this.isGoal;
        data["sortOrder"] = this.sortOrder;
        data["percentOfTarget"] = this.percentOfTarget;
        if (Array.isArray(this.foods)) {
            data["foods"] = [];
            for (let item of this.foods)
                data["foods"].push(item.toJSON());
        }
        return data;
    }
}

export interface INutrientBreakdown {
    nutrientKey?: string | undefined;
    nutrientName?: string | undefined;
    unit?: string | undefined;
    totalAmount?: number;
    targetValue?: number | undefined;
    minTarget?: number | undefined;
    maxTarget?: number | undefined;
    isGoal?: boolean;
    sortOrder?: number;
    percentOfTarget?: number | undefined;
    foods?: FoodContribution[] | undefined;
}

export class NutrientCompositionEntry implements INutrientCompositionEntry {
    sourceKey?: string | undefined;
    displayName?: string | undefined;
    provider?: NutritionProvider;
    providerAttrId?: number;
    rawValue?: number;
    normalizedValue?: number;
    unit?: string | undefined;

    constructor(data?: INutrientCompositionEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceKey = _data["sourceKey"];
            this.displayName = _data["displayName"];
            this.provider = _data["provider"];
            this.providerAttrId = _data["providerAttrId"];
            this.rawValue = _data["rawValue"];
            this.normalizedValue = _data["normalizedValue"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): NutrientCompositionEntry {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientCompositionEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceKey"] = this.sourceKey;
        data["displayName"] = this.displayName;
        data["provider"] = this.provider;
        data["providerAttrId"] = this.providerAttrId;
        data["rawValue"] = this.rawValue;
        data["normalizedValue"] = this.normalizedValue;
        data["unit"] = this.unit;
        return data;
    }
}

export interface INutrientCompositionEntry {
    sourceKey?: string | undefined;
    displayName?: string | undefined;
    provider?: NutritionProvider;
    providerAttrId?: number;
    rawValue?: number;
    normalizedValue?: number;
    unit?: string | undefined;
}

export class NutrientContribution implements INutrientContribution {
    nutrientKey?: string | undefined;
    nutrientName?: string | undefined;
    name?: string | undefined;
    brandName?: string | undefined;
    amount?: number;
    unit?: string | undefined;
    originalUnit?: string | undefined;

    constructor(data?: INutrientContribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nutrientKey = _data["nutrientKey"];
            this.nutrientName = _data["nutrientName"];
            this.name = _data["name"];
            this.brandName = _data["brandName"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
            this.originalUnit = _data["originalUnit"];
        }
    }

    static fromJS(data: any): NutrientContribution {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientContribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nutrientKey"] = this.nutrientKey;
        data["nutrientName"] = this.nutrientName;
        data["name"] = this.name;
        data["brandName"] = this.brandName;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        data["originalUnit"] = this.originalUnit;
        return data;
    }
}

export interface INutrientContribution {
    nutrientKey?: string | undefined;
    nutrientName?: string | undefined;
    name?: string | undefined;
    brandName?: string | undefined;
    amount?: number;
    unit?: string | undefined;
    originalUnit?: string | undefined;
}

export class NutrientTarget implements INutrientTarget {
    nutrientKey?: string | undefined;
    targetValue?: number | undefined;
    isDefault?: boolean;
    isGoal?: boolean;

    constructor(data?: INutrientTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nutrientKey = _data["nutrientKey"];
            this.targetValue = _data["targetValue"];
            this.isDefault = _data["isDefault"];
            this.isGoal = _data["isGoal"];
        }
    }

    static fromJS(data: any): NutrientTarget {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientTarget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nutrientKey"] = this.nutrientKey;
        data["targetValue"] = this.targetValue;
        data["isDefault"] = this.isDefault;
        data["isGoal"] = this.isGoal;
        return data;
    }
}

export interface INutrientTarget {
    nutrientKey?: string | undefined;
    targetValue?: number | undefined;
    isDefault?: boolean;
    isGoal?: boolean;
}

export enum NutritionProvider {
    Nutritionix = "Nutritionix",
    Usda = "Usda",
}

export class OnboardingProgress implements IOnboardingProgress {
    hasLoggedFirstMeal?: boolean;
    hasSeenSignupPrompt?: boolean;
    meaningfulInteractionCount?: number;
    lastInteractionDateKey?: string | undefined;
    hasDismissedAppDownloadBannerToday?: boolean;

    constructor(data?: IOnboardingProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasLoggedFirstMeal = _data["hasLoggedFirstMeal"];
            this.hasSeenSignupPrompt = _data["hasSeenSignupPrompt"];
            this.meaningfulInteractionCount = _data["meaningfulInteractionCount"];
            this.lastInteractionDateKey = _data["lastInteractionDateKey"];
            this.hasDismissedAppDownloadBannerToday = _data["hasDismissedAppDownloadBannerToday"];
        }
    }

    static fromJS(data: any): OnboardingProgress {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasLoggedFirstMeal"] = this.hasLoggedFirstMeal;
        data["hasSeenSignupPrompt"] = this.hasSeenSignupPrompt;
        data["meaningfulInteractionCount"] = this.meaningfulInteractionCount;
        data["lastInteractionDateKey"] = this.lastInteractionDateKey;
        data["hasDismissedAppDownloadBannerToday"] = this.hasDismissedAppDownloadBannerToday;
        return data;
    }
}

export interface IOnboardingProgress {
    hasLoggedFirstMeal?: boolean;
    hasSeenSignupPrompt?: boolean;
    meaningfulInteractionCount?: number;
    lastInteractionDateKey?: string | undefined;
    hasDismissedAppDownloadBannerToday?: boolean;
}

export class OpenAiFile implements IOpenAiFile {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    type?: string | undefined;
    openAiFileId?: string | undefined;
    vectorStoreId?: string | undefined;
    fileName?: string | undefined;
    fileSize?: number;
    contentType?: string | undefined;
    fileSha256Hash?: string | undefined;
    uploadedByAccountId?: string | undefined;
    status?: string | undefined;
    errorMessage?: string | undefined;
    cloudStorageObjectName?: string | undefined;

    constructor(data?: IOpenAiFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.lastUpdatedDateUtc = _data["lastUpdatedDateUtc"] ? new Date(_data["lastUpdatedDateUtc"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.openAiFileId = _data["openAiFileId"];
            this.vectorStoreId = _data["vectorStoreId"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.contentType = _data["contentType"];
            this.fileSha256Hash = _data["fileSha256Hash"];
            this.uploadedByAccountId = _data["uploadedByAccountId"];
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
            this.cloudStorageObjectName = _data["cloudStorageObjectName"];
        }
    }

    static fromJS(data: any): OpenAiFile {
        data = typeof data === 'object' ? data : {};
        let result = new OpenAiFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["lastUpdatedDateUtc"] = this.lastUpdatedDateUtc ? this.lastUpdatedDateUtc.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["openAiFileId"] = this.openAiFileId;
        data["vectorStoreId"] = this.vectorStoreId;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["contentType"] = this.contentType;
        data["fileSha256Hash"] = this.fileSha256Hash;
        data["uploadedByAccountId"] = this.uploadedByAccountId;
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        data["cloudStorageObjectName"] = this.cloudStorageObjectName;
        return data;
    }
}

export interface IOpenAiFile {
    id?: string | undefined;
    createdDateUtc?: Date;
    lastUpdatedDateUtc?: Date;
    type?: string | undefined;
    openAiFileId?: string | undefined;
    vectorStoreId?: string | undefined;
    fileName?: string | undefined;
    fileSize?: number;
    contentType?: string | undefined;
    fileSha256Hash?: string | undefined;
    uploadedByAccountId?: string | undefined;
    status?: string | undefined;
    errorMessage?: string | undefined;
    cloudStorageObjectName?: string | undefined;
}

export class OutboundConnectionResponse implements IOutboundConnectionResponse {
    connectionId?: string | undefined;
    window?: string | undefined;

    constructor(data?: IOutboundConnectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionId = _data["connectionId"];
            this.window = _data["window"];
        }
    }

    static fromJS(data: any): OutboundConnectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OutboundConnectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionId"] = this.connectionId;
        data["window"] = this.window;
        return data;
    }
}

export interface IOutboundConnectionResponse {
    connectionId?: string | undefined;
    window?: string | undefined;
}

export class PhotoSearchRequest implements IPhotoSearchRequest {
    imageBase64?: string | undefined;
    messageId?: string | undefined;
    localDateKey?: string | undefined;
    userContext?: string | undefined;

    constructor(data?: IPhotoSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageBase64 = _data["imageBase64"];
            this.messageId = _data["messageId"];
            this.localDateKey = _data["localDateKey"];
            this.userContext = _data["userContext"];
        }
    }

    static fromJS(data: any): PhotoSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageBase64"] = this.imageBase64;
        data["messageId"] = this.messageId;
        data["localDateKey"] = this.localDateKey;
        data["userContext"] = this.userContext;
        return data;
    }
}

export interface IPhotoSearchRequest {
    imageBase64?: string | undefined;
    messageId?: string | undefined;
    localDateKey?: string | undefined;
    userContext?: string | undefined;
}

export enum PhotoType {
    PackageFront = "PackageFront",
    TextPhoto = "TextPhoto",
    FoodPhoto = "FoodPhoto",
    NutritionLabel = "NutritionLabel",
    Menu = "Menu",
    Unknown = "Unknown",
}

export class RegisterAccountRequest implements IRegisterAccountRequest {
    email?: string | undefined;
    timeZoneId?: string | undefined;
    isAnonymous?: boolean;
    marketingEmailsOptIn?: boolean;
    referrer?: string | undefined;
    referrerId?: string | undefined;

    constructor(data?: IRegisterAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.timeZoneId = _data["timeZoneId"];
            this.isAnonymous = _data["isAnonymous"];
            this.marketingEmailsOptIn = _data["marketingEmailsOptIn"];
            this.referrer = _data["referrer"];
            this.referrerId = _data["referrerId"];
        }
    }

    static fromJS(data: any): RegisterAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["timeZoneId"] = this.timeZoneId;
        data["isAnonymous"] = this.isAnonymous;
        data["marketingEmailsOptIn"] = this.marketingEmailsOptIn;
        data["referrer"] = this.referrer;
        data["referrerId"] = this.referrerId;
        return data;
    }
}

export interface IRegisterAccountRequest {
    email?: string | undefined;
    timeZoneId?: string | undefined;
    isAnonymous?: boolean;
    marketingEmailsOptIn?: boolean;
    referrer?: string | undefined;
    referrerId?: string | undefined;
}

export class RegisterDeviceRequest implements IRegisterDeviceRequest {
    installId?: string | undefined;
    platform?: string | undefined;
    fcmToken?: string | undefined;

    constructor(data?: IRegisterDeviceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installId = _data["installId"];
            this.platform = _data["platform"];
            this.fcmToken = _data["fcmToken"];
        }
    }

    static fromJS(data: any): RegisterDeviceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installId"] = this.installId;
        data["platform"] = this.platform;
        data["fcmToken"] = this.fcmToken;
        return data;
    }
}

export interface IRegisterDeviceRequest {
    installId?: string | undefined;
    platform?: string | undefined;
    fcmToken?: string | undefined;
}

export class RelogFavoriteRequest implements IRelogFavoriteRequest {
    favoriteId?: string | undefined;
    localDateKey?: string | undefined;
    mealName?: string | undefined;
    messageId?: string | undefined;

    constructor(data?: IRelogFavoriteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favoriteId = _data["favoriteId"];
            this.localDateKey = _data["localDateKey"];
            this.mealName = _data["mealName"];
            this.messageId = _data["messageId"];
        }
    }

    static fromJS(data: any): RelogFavoriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RelogFavoriteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favoriteId"] = this.favoriteId;
        data["localDateKey"] = this.localDateKey;
        data["mealName"] = this.mealName;
        data["messageId"] = this.messageId;
        return data;
    }
}

export interface IRelogFavoriteRequest {
    favoriteId?: string | undefined;
    localDateKey?: string | undefined;
    mealName?: string | undefined;
    messageId?: string | undefined;
}

export class RelogFavoriteResponse implements IRelogFavoriteResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    food?: Food;

    constructor(data?: IRelogFavoriteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.food = _data["food"] ? Food.fromJS(_data["food"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RelogFavoriteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RelogFavoriteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["food"] = this.food ? this.food.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRelogFavoriteResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    food?: Food;
}

export class RemoveFavoriteRequest implements IRemoveFavoriteRequest {
    favoriteId?: string | undefined;

    constructor(data?: IRemoveFavoriteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favoriteId = _data["favoriteId"];
        }
    }

    static fromJS(data: any): RemoveFavoriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFavoriteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favoriteId"] = this.favoriteId;
        return data;
    }
}

export interface IRemoveFavoriteRequest {
    favoriteId?: string | undefined;
}

export class RemoveFavoriteResponse implements IRemoveFavoriteResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;

    constructor(data?: IRemoveFavoriteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
        }
    }

    static fromJS(data: any): RemoveFavoriteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFavoriteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        return data;
    }
}

export interface IRemoveFavoriteResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
}

export class RemoveSharedMealsResponse implements IRemoveSharedMealsResponse {
    queuedDeletes?: number;

    constructor(data?: IRemoveSharedMealsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queuedDeletes = _data["queuedDeletes"];
        }
    }

    static fromJS(data: any): RemoveSharedMealsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveSharedMealsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queuedDeletes"] = this.queuedDeletes;
        return data;
    }
}

export interface IRemoveSharedMealsResponse {
    queuedDeletes?: number;
}

export class Request implements IRequest {

    constructor(data?: IRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Request {
        data = typeof data === 'object' ? data : {};
        let result = new Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRequest {
}

export class Response implements IResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        return data;
    }
}

export interface IResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
}

export class RunChatRequest implements IRunChatRequest {
    message?: string | undefined;
    localDateKey?: string | undefined;
    retryCount?: number | undefined;
    images?: string[] | undefined;

    constructor(data?: IRunChatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.localDateKey = _data["localDateKey"];
            this.retryCount = _data["retryCount"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
        }
    }

    static fromJS(data: any): RunChatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RunChatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["localDateKey"] = this.localDateKey;
        data["retryCount"] = this.retryCount;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }
}

export interface IRunChatRequest {
    message?: string | undefined;
    localDateKey?: string | undefined;
    retryCount?: number | undefined;
    images?: string[] | undefined;
}

export class RunScheduledNotificationsResponse implements IRunScheduledNotificationsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accountsEvaluated?: number;
    notificationsSent?: number;
    snoozeRetriesSent?: number;
    notificationsSkipped?: number;

    constructor(data?: IRunScheduledNotificationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.accountsEvaluated = _data["accountsEvaluated"];
            this.notificationsSent = _data["notificationsSent"];
            this.snoozeRetriesSent = _data["snoozeRetriesSent"];
            this.notificationsSkipped = _data["notificationsSkipped"];
        }
    }

    static fromJS(data: any): RunScheduledNotificationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RunScheduledNotificationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["accountsEvaluated"] = this.accountsEvaluated;
        data["notificationsSent"] = this.notificationsSent;
        data["snoozeRetriesSent"] = this.snoozeRetriesSent;
        data["notificationsSkipped"] = this.notificationsSkipped;
        return data;
    }
}

export interface IRunScheduledNotificationsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accountsEvaluated?: number;
    notificationsSent?: number;
    snoozeRetriesSent?: number;
    notificationsSkipped?: number;
}

export class SearchFoodPhraseRequest implements ISearchFoodPhraseRequest {
    searchPhrase?: string | undefined;
    localDateKey?: string | undefined;
    originalPhrase?: string | undefined;
    messageId?: string | undefined;
    componentId?: string | undefined;
    foodEntryId?: string | undefined;
    parentFoodName?: string | undefined;
    parentFoodSingularUnit?: string | undefined;
    parentFoodPluralUnit?: string | undefined;
    existingComponents?: ComponentDescription[] | undefined;

    constructor(data?: ISearchFoodPhraseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchPhrase = _data["searchPhrase"];
            this.localDateKey = _data["localDateKey"];
            this.originalPhrase = _data["originalPhrase"];
            this.messageId = _data["messageId"];
            this.componentId = _data["componentId"];
            this.foodEntryId = _data["foodEntryId"];
            this.parentFoodName = _data["parentFoodName"];
            this.parentFoodSingularUnit = _data["parentFoodSingularUnit"];
            this.parentFoodPluralUnit = _data["parentFoodPluralUnit"];
            if (Array.isArray(_data["existingComponents"])) {
                this.existingComponents = [] as any;
                for (let item of _data["existingComponents"])
                    this.existingComponents!.push(ComponentDescription.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchFoodPhraseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFoodPhraseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchPhrase"] = this.searchPhrase;
        data["localDateKey"] = this.localDateKey;
        data["originalPhrase"] = this.originalPhrase;
        data["messageId"] = this.messageId;
        data["componentId"] = this.componentId;
        data["foodEntryId"] = this.foodEntryId;
        data["parentFoodName"] = this.parentFoodName;
        data["parentFoodSingularUnit"] = this.parentFoodSingularUnit;
        data["parentFoodPluralUnit"] = this.parentFoodPluralUnit;
        if (Array.isArray(this.existingComponents)) {
            data["existingComponents"] = [];
            for (let item of this.existingComponents)
                data["existingComponents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchFoodPhraseRequest {
    searchPhrase?: string | undefined;
    localDateKey?: string | undefined;
    originalPhrase?: string | undefined;
    messageId?: string | undefined;
    componentId?: string | undefined;
    foodEntryId?: string | undefined;
    parentFoodName?: string | undefined;
    parentFoodSingularUnit?: string | undefined;
    parentFoodPluralUnit?: string | undefined;
    existingComponents?: ComponentDescription[] | undefined;
}

export class SearchFoodPhraseResponse implements ISearchFoodPhraseResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    searchPhrase?: string | undefined;
    foodOptions?: Food[] | undefined;
    supported?: boolean | undefined;
    detectedPhotoType?: PhotoType;

    constructor(data?: ISearchFoodPhraseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.searchPhrase = _data["searchPhrase"];
            if (Array.isArray(_data["foodOptions"])) {
                this.foodOptions = [] as any;
                for (let item of _data["foodOptions"])
                    this.foodOptions!.push(Food.fromJS(item));
            }
            this.supported = _data["supported"];
            this.detectedPhotoType = _data["detectedPhotoType"];
        }
    }

    static fromJS(data: any): SearchFoodPhraseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFoodPhraseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["searchPhrase"] = this.searchPhrase;
        if (Array.isArray(this.foodOptions)) {
            data["foodOptions"] = [];
            for (let item of this.foodOptions)
                data["foodOptions"].push(item.toJSON());
        }
        data["supported"] = this.supported;
        data["detectedPhotoType"] = this.detectedPhotoType;
        return data;
    }
}

export interface ISearchFoodPhraseResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    searchPhrase?: string | undefined;
    foodOptions?: Food[] | undefined;
    supported?: boolean | undefined;
    detectedPhotoType?: PhotoType;
}

export class SearchLogsRequest implements ISearchLogsRequest {
    accountId?: string | undefined;
    email?: string | undefined;
    contains?: string | undefined;
    severity?: string | undefined;
    traceId?: string | undefined;
    minutesBack?: number | undefined;
    pageSize?: number | undefined;
    pageToken?: string | undefined;

    constructor(data?: ISearchLogsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.email = _data["email"];
            this.contains = _data["contains"];
            this.severity = _data["severity"];
            this.traceId = _data["traceId"];
            this.minutesBack = _data["minutesBack"];
            this.pageSize = _data["pageSize"];
            this.pageToken = _data["pageToken"];
        }
    }

    static fromJS(data: any): SearchLogsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLogsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["email"] = this.email;
        data["contains"] = this.contains;
        data["severity"] = this.severity;
        data["traceId"] = this.traceId;
        data["minutesBack"] = this.minutesBack;
        data["pageSize"] = this.pageSize;
        data["pageToken"] = this.pageToken;
        return data;
    }
}

export interface ISearchLogsRequest {
    accountId?: string | undefined;
    email?: string | undefined;
    contains?: string | undefined;
    severity?: string | undefined;
    traceId?: string | undefined;
    minutesBack?: number | undefined;
    pageSize?: number | undefined;
    pageToken?: string | undefined;
}

export class SearchLogsResponse implements ISearchLogsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    items?: LogEntryDto[] | undefined;
    nextPageToken?: string | undefined;

    constructor(data?: ISearchLogsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LogEntryDto.fromJS(item));
            }
            this.nextPageToken = _data["nextPageToken"];
        }
    }

    static fromJS(data: any): SearchLogsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLogsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["nextPageToken"] = this.nextPageToken;
        return data;
    }
}

export interface ISearchLogsResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    items?: LogEntryDto[] | undefined;
    nextPageToken?: string | undefined;
}

export class SendBulkNotificationRequest implements ISendBulkNotificationRequest {
    accountIds?: string[] | undefined;
    title?: string | undefined;
    body?: string | undefined;
    data?: { [key: string]: string; } | undefined;

    constructor(data?: ISendBulkNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            this.title = _data["title"];
            this.body = _data["body"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): SendBulkNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendBulkNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        data["title"] = this.title;
        data["body"] = this.body;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        return data;
    }
}

export interface ISendBulkNotificationRequest {
    accountIds?: string[] | undefined;
    title?: string | undefined;
    body?: string | undefined;
    data?: { [key: string]: string; } | undefined;
}

export class SendBulkNotificationResponse implements ISendBulkNotificationResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    totalAccounts?: number;
    totalDevicesSent?: number;
    totalDevicesFailed?: number;
    accountsWithNoDevices?: number;
    accountResults?: BulkNotificationAccountResult[] | undefined;

    constructor(data?: ISendBulkNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.totalAccounts = _data["totalAccounts"];
            this.totalDevicesSent = _data["totalDevicesSent"];
            this.totalDevicesFailed = _data["totalDevicesFailed"];
            this.accountsWithNoDevices = _data["accountsWithNoDevices"];
            if (Array.isArray(_data["accountResults"])) {
                this.accountResults = [] as any;
                for (let item of _data["accountResults"])
                    this.accountResults!.push(BulkNotificationAccountResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendBulkNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendBulkNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["totalAccounts"] = this.totalAccounts;
        data["totalDevicesSent"] = this.totalDevicesSent;
        data["totalDevicesFailed"] = this.totalDevicesFailed;
        data["accountsWithNoDevices"] = this.accountsWithNoDevices;
        if (Array.isArray(this.accountResults)) {
            data["accountResults"] = [];
            for (let item of this.accountResults)
                data["accountResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendBulkNotificationResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    totalAccounts?: number;
    totalDevicesSent?: number;
    totalDevicesFailed?: number;
    accountsWithNoDevices?: number;
    accountResults?: BulkNotificationAccountResult[] | undefined;
}

export class SendNotificationRequest implements ISendNotificationRequest {
    accountId?: string | undefined;
    title?: string | undefined;
    body?: string | undefined;
    data?: { [key: string]: string; } | undefined;

    constructor(data?: ISendNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.title = _data["title"];
            this.body = _data["body"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): SendNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["title"] = this.title;
        data["body"] = this.body;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        return data;
    }
}

export interface ISendNotificationRequest {
    accountId?: string | undefined;
    title?: string | undefined;
    body?: string | undefined;
    data?: { [key: string]: string; } | undefined;
}

export class SendNotificationResponse implements ISendNotificationResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    devicesSent?: number;
    devicesFailed?: number;

    constructor(data?: ISendNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.devicesSent = _data["devicesSent"];
            this.devicesFailed = _data["devicesFailed"];
        }
    }

    static fromJS(data: any): SendNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["devicesSent"] = this.devicesSent;
        data["devicesFailed"] = this.devicesFailed;
        return data;
    }
}

export interface ISendNotificationResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    devicesSent?: number;
    devicesFailed?: number;
}

export class ServingIdentifier implements IServingIdentifier {
    provider?: string | undefined;
    foodType?: string | undefined;
    foodName?: string | undefined;
    variantIndex?: number;
    servingType?: string | undefined;

    constructor(data?: IServingIdentifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.foodType = _data["foodType"];
            this.foodName = _data["foodName"];
            this.variantIndex = _data["variantIndex"];
            this.servingType = _data["servingType"];
        }
    }

    static fromJS(data: any): ServingIdentifier {
        data = typeof data === 'object' ? data : {};
        let result = new ServingIdentifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["foodType"] = this.foodType;
        data["foodName"] = this.foodName;
        data["variantIndex"] = this.variantIndex;
        data["servingType"] = this.servingType;
        return data;
    }
}

export interface IServingIdentifier {
    provider?: string | undefined;
    foodType?: string | undefined;
    foodName?: string | undefined;
    variantIndex?: number;
    servingType?: string | undefined;
}

export class SetTrialEndDateRequest implements ISetTrialEndDateRequest {
    accountId?: string | undefined;
    trialEndDateUtc?: Date | undefined;

    constructor(data?: ISetTrialEndDateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.trialEndDateUtc = _data["trialEndDateUtc"] ? new Date(_data["trialEndDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SetTrialEndDateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTrialEndDateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["trialEndDateUtc"] = this.trialEndDateUtc ? this.trialEndDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISetTrialEndDateRequest {
    accountId?: string | undefined;
    trialEndDateUtc?: Date | undefined;
}

export class SetTrialEndDateResponse implements ISetTrialEndDateResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accountId?: string | undefined;
    previousTrialEndDateUtc?: Date | undefined;
    newTrialEndDateUtc?: Date | undefined;

    constructor(data?: ISetTrialEndDateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.accountId = _data["accountId"];
            this.previousTrialEndDateUtc = _data["previousTrialEndDateUtc"] ? new Date(_data["previousTrialEndDateUtc"].toString()) : <any>undefined;
            this.newTrialEndDateUtc = _data["newTrialEndDateUtc"] ? new Date(_data["newTrialEndDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SetTrialEndDateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetTrialEndDateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["accountId"] = this.accountId;
        data["previousTrialEndDateUtc"] = this.previousTrialEndDateUtc ? this.previousTrialEndDateUtc.toISOString() : <any>undefined;
        data["newTrialEndDateUtc"] = this.newTrialEndDateUtc ? this.newTrialEndDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISetTrialEndDateResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    accountId?: string | undefined;
    previousTrialEndDateUtc?: Date | undefined;
    newTrialEndDateUtc?: Date | undefined;
}

export class SetupGoalsRequest implements ISetupGoalsRequest {
    localDateKey?: string | undefined;
    isTweaking?: boolean;
    contextNote?: string | undefined;

    constructor(data?: ISetupGoalsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDateKey = _data["localDateKey"];
            this.isTweaking = _data["isTweaking"];
            this.contextNote = _data["contextNote"];
        }
    }

    static fromJS(data: any): SetupGoalsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetupGoalsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDateKey"] = this.localDateKey;
        data["isTweaking"] = this.isTweaking;
        data["contextNote"] = this.contextNote;
        return data;
    }
}

export interface ISetupGoalsRequest {
    localDateKey?: string | undefined;
    isTweaking?: boolean;
    contextNote?: string | undefined;
}

export class SetupNotificationsRequest implements ISetupNotificationsRequest {
    localDateKey?: string | undefined;
    contextNote?: string | undefined;

    constructor(data?: ISetupNotificationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDateKey = _data["localDateKey"];
            this.contextNote = _data["contextNote"];
        }
    }

    static fromJS(data: any): SetupNotificationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetupNotificationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDateKey"] = this.localDateKey;
        data["contextNote"] = this.contextNote;
        return data;
    }
}

export interface ISetupNotificationsRequest {
    localDateKey?: string | undefined;
    contextNote?: string | undefined;
}

export class SetupPreferencesRequest implements ISetupPreferencesRequest {
    localDateKey?: string | undefined;
    contextNote?: string | undefined;

    constructor(data?: ISetupPreferencesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDateKey = _data["localDateKey"];
            this.contextNote = _data["contextNote"];
        }
    }

    static fromJS(data: any): SetupPreferencesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetupPreferencesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDateKey"] = this.localDateKey;
        data["contextNote"] = this.contextNote;
        return data;
    }
}

export interface ISetupPreferencesRequest {
    localDateKey?: string | undefined;
    contextNote?: string | undefined;
}

export class ShowLoggingExampleRequest implements IShowLoggingExampleRequest {
    localDateKey!: string;
    contextNote?: string | undefined;

    constructor(data?: IShowLoggingExampleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDateKey = _data["localDateKey"];
            this.contextNote = _data["contextNote"];
        }
    }

    static fromJS(data: any): ShowLoggingExampleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShowLoggingExampleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDateKey"] = this.localDateKey;
        data["contextNote"] = this.contextNote;
        return data;
    }
}

export interface IShowLoggingExampleRequest {
    localDateKey: string;
    contextNote?: string | undefined;
}

export class ShowRestrictedMessageRequest implements IShowRestrictedMessageRequest {
    phase?: string | undefined;
    localDateKey?: string | undefined;

    constructor(data?: IShowRestrictedMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phase = _data["phase"];
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): ShowRestrictedMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShowRestrictedMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phase"] = this.phase;
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface IShowRestrictedMessageRequest {
    phase?: string | undefined;
    localDateKey?: string | undefined;
}

export class SubmitEditServingSelectionRequest implements ISubmitEditServingSelectionRequest {
    pendingMessageId?: string | undefined;
    foodEntryId?: string | undefined;
    foodId?: string | undefined;
    componentId?: string | undefined;
    localDateKey?: string | undefined;
    selections?: UserSelectedServing[] | undefined;
    foodQuantities?: UserSelectedFoodQuantity[] | undefined;
    foods?: Food[] | undefined;
    mealName?: string | undefined;

    constructor(data?: ISubmitEditServingSelectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingMessageId = _data["pendingMessageId"];
            this.foodEntryId = _data["foodEntryId"];
            this.foodId = _data["foodId"];
            this.componentId = _data["componentId"];
            this.localDateKey = _data["localDateKey"];
            if (Array.isArray(_data["selections"])) {
                this.selections = [] as any;
                for (let item of _data["selections"])
                    this.selections!.push(UserSelectedServing.fromJS(item));
            }
            if (Array.isArray(_data["foodQuantities"])) {
                this.foodQuantities = [] as any;
                for (let item of _data["foodQuantities"])
                    this.foodQuantities!.push(UserSelectedFoodQuantity.fromJS(item));
            }
            if (Array.isArray(_data["foods"])) {
                this.foods = [] as any;
                for (let item of _data["foods"])
                    this.foods!.push(Food.fromJS(item));
            }
            this.mealName = _data["mealName"];
        }
    }

    static fromJS(data: any): SubmitEditServingSelectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitEditServingSelectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingMessageId"] = this.pendingMessageId;
        data["foodEntryId"] = this.foodEntryId;
        data["foodId"] = this.foodId;
        data["componentId"] = this.componentId;
        data["localDateKey"] = this.localDateKey;
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item.toJSON());
        }
        if (Array.isArray(this.foodQuantities)) {
            data["foodQuantities"] = [];
            for (let item of this.foodQuantities)
                data["foodQuantities"].push(item.toJSON());
        }
        if (Array.isArray(this.foods)) {
            data["foods"] = [];
            for (let item of this.foods)
                data["foods"].push(item.toJSON());
        }
        data["mealName"] = this.mealName;
        return data;
    }
}

export interface ISubmitEditServingSelectionRequest {
    pendingMessageId?: string | undefined;
    foodEntryId?: string | undefined;
    foodId?: string | undefined;
    componentId?: string | undefined;
    localDateKey?: string | undefined;
    selections?: UserSelectedServing[] | undefined;
    foodQuantities?: UserSelectedFoodQuantity[] | undefined;
    foods?: Food[] | undefined;
    mealName?: string | undefined;
}

export class SubmitServingSelectionRequest implements ISubmitServingSelectionRequest {
    localDateKey?: string | undefined;
    pendingMessageId?: string | undefined;
    selections?: UserSelectedServing[] | undefined;
    foodQuantities?: UserSelectedFoodQuantity[] | undefined;

    constructor(data?: ISubmitServingSelectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDateKey = _data["localDateKey"];
            this.pendingMessageId = _data["pendingMessageId"];
            if (Array.isArray(_data["selections"])) {
                this.selections = [] as any;
                for (let item of _data["selections"])
                    this.selections!.push(UserSelectedServing.fromJS(item));
            }
            if (Array.isArray(_data["foodQuantities"])) {
                this.foodQuantities = [] as any;
                for (let item of _data["foodQuantities"])
                    this.foodQuantities!.push(UserSelectedFoodQuantity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmitServingSelectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitServingSelectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDateKey"] = this.localDateKey;
        data["pendingMessageId"] = this.pendingMessageId;
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item.toJSON());
        }
        if (Array.isArray(this.foodQuantities)) {
            data["foodQuantities"] = [];
            for (let item of this.foodQuantities)
                data["foodQuantities"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubmitServingSelectionRequest {
    localDateKey?: string | undefined;
    pendingMessageId?: string | undefined;
    selections?: UserSelectedServing[] | undefined;
    foodQuantities?: UserSelectedFoodQuantity[] | undefined;
}

export enum SubscriptionStatus {
    Trial = "Trial",
    Active = "Active",
    PastDue = "PastDue",
    Canceled = "Canceled",
    Expired = "Expired",
    Incomplete = "Incomplete",
}

export class TelemetryContext implements ITelemetryContext {
    buildStamp?: BuildStamp;
    environment?: string | undefined;
    userAgent?: string | undefined;
    extras?: { [key: string]: string; } | undefined;

    constructor(data?: ITelemetryContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildStamp = _data["buildStamp"] ? BuildStamp.fromJS(_data["buildStamp"]) : <any>undefined;
            this.environment = _data["environment"];
            this.userAgent = _data["userAgent"];
            if (_data["extras"]) {
                this.extras = {} as any;
                for (let key in _data["extras"]) {
                    if (_data["extras"].hasOwnProperty(key))
                        (<any>this.extras)![key] = _data["extras"][key];
                }
            }
        }
    }

    static fromJS(data: any): TelemetryContext {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildStamp"] = this.buildStamp ? this.buildStamp.toJSON() : <any>undefined;
        data["environment"] = this.environment;
        data["userAgent"] = this.userAgent;
        if (this.extras) {
            data["extras"] = {};
            for (let key in this.extras) {
                if (this.extras.hasOwnProperty(key))
                    (<any>data["extras"])[key] = (<any>this.extras)[key];
            }
        }
        return data;
    }
}

export interface ITelemetryContext {
    buildStamp?: BuildStamp;
    environment?: string | undefined;
    userAgent?: string | undefined;
    extras?: { [key: string]: string; } | undefined;
}

export class TriggerActionRequest implements ITriggerActionRequest {
    actionName?: string | undefined;
    localDateKey?: string | undefined;

    constructor(data?: ITriggerActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionName = _data["actionName"];
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): TriggerActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionName"] = this.actionName;
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface ITriggerActionRequest {
    actionName?: string | undefined;
    localDateKey?: string | undefined;
}

export class TriggerConversationContinuationRequest implements ITriggerConversationContinuationRequest {
    localDateKey?: string | undefined;

    constructor(data?: ITriggerConversationContinuationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDateKey = _data["localDateKey"];
        }
    }

    static fromJS(data: any): TriggerConversationContinuationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerConversationContinuationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDateKey"] = this.localDateKey;
        return data;
    }
}

export interface ITriggerConversationContinuationRequest {
    localDateKey?: string | undefined;
}

export enum UnitKind {
    Weight = "Weight",
    Volume = "Volume",
    Count = "Count",
    Unknown = "Unknown",
}

export class UpdateMealSelectionRequest implements IUpdateMealSelectionRequest {
    messageId?: string | undefined;
    localDateKey?: string | undefined;
    foods?: Food[] | undefined;
    mealName?: string | undefined;

    constructor(data?: IUpdateMealSelectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.localDateKey = _data["localDateKey"];
            if (Array.isArray(_data["foods"])) {
                this.foods = [] as any;
                for (let item of _data["foods"])
                    this.foods!.push(Food.fromJS(item));
            }
            this.mealName = _data["mealName"];
        }
    }

    static fromJS(data: any): UpdateMealSelectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMealSelectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["localDateKey"] = this.localDateKey;
        if (Array.isArray(this.foods)) {
            data["foods"] = [];
            for (let item of this.foods)
                data["foods"].push(item.toJSON());
        }
        data["mealName"] = this.mealName;
        return data;
    }
}

export interface IUpdateMealSelectionRequest {
    messageId?: string | undefined;
    localDateKey?: string | undefined;
    foods?: Food[] | undefined;
    mealName?: string | undefined;
}

export class UploadDailyEnergyBatchRequest implements IUploadDailyEnergyBatchRequest {
    installationId?: string | undefined;
    platform?: string | undefined;
    days?: DailyEnergyUpload[] | undefined;
    nextCursor?: string | undefined;

    constructor(data?: IUploadDailyEnergyBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.platform = _data["platform"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(DailyEnergyUpload.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
        }
    }

    static fromJS(data: any): UploadDailyEnergyBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDailyEnergyBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["platform"] = this.platform;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        data["nextCursor"] = this.nextCursor;
        return data;
    }
}

export interface IUploadDailyEnergyBatchRequest {
    installationId?: string | undefined;
    platform?: string | undefined;
    days?: DailyEnergyUpload[] | undefined;
    nextCursor?: string | undefined;
}

export class UploadGuidelineFileRequest implements IUploadGuidelineFileRequest {
    fileName?: string | undefined;
    contentType?: string | undefined;
    base64Data?: string | undefined;

    constructor(data?: IUploadGuidelineFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.base64Data = _data["base64Data"];
        }
    }

    static fromJS(data: any): UploadGuidelineFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UploadGuidelineFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["base64Data"] = this.base64Data;
        return data;
    }
}

export interface IUploadGuidelineFileRequest {
    fileName?: string | undefined;
    contentType?: string | undefined;
    base64Data?: string | undefined;
}

export class UploadGuidelineFileResponse implements IUploadGuidelineFileResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    openAiFileId?: string | undefined;
    openAiFileApiId?: string | undefined;
    vectorStoreId?: string | undefined;
    status?: string | undefined;

    constructor(data?: IUploadGuidelineFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.openAiFileId = _data["openAiFileId"];
            this.openAiFileApiId = _data["openAiFileApiId"];
            this.vectorStoreId = _data["vectorStoreId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UploadGuidelineFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadGuidelineFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["openAiFileId"] = this.openAiFileId;
        data["openAiFileApiId"] = this.openAiFileApiId;
        data["vectorStoreId"] = this.vectorStoreId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUploadGuidelineFileResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    openAiFileId?: string | undefined;
    openAiFileApiId?: string | undefined;
    vectorStoreId?: string | undefined;
    status?: string | undefined;
}

export class UserSelectedFoodQuantity implements IUserSelectedFoodQuantity {
    foodId?: string | undefined;
    quantity?: number;

    constructor(data?: IUserSelectedFoodQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.foodId = _data["foodId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): UserSelectedFoodQuantity {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectedFoodQuantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foodId"] = this.foodId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IUserSelectedFoodQuantity {
    foodId?: string | undefined;
    quantity?: number;
}

export class UserSelectedServing implements IUserSelectedServing {
    originalText?: string | undefined;
    provider?: string | undefined;
    providerFoodId?: string | undefined;
    servingId?: ServingIdentifier;
    editedQuantity?: number | undefined;
    componentId?: string | undefined;
    scaledQuantity?: number | undefined;

    constructor(data?: IUserSelectedServing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalText = _data["originalText"];
            this.provider = _data["provider"];
            this.providerFoodId = _data["providerFoodId"];
            this.servingId = _data["servingId"] ? ServingIdentifier.fromJS(_data["servingId"]) : <any>undefined;
            this.editedQuantity = _data["editedQuantity"];
            this.componentId = _data["componentId"];
            this.scaledQuantity = _data["scaledQuantity"];
        }
    }

    static fromJS(data: any): UserSelectedServing {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectedServing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalText"] = this.originalText;
        data["provider"] = this.provider;
        data["providerFoodId"] = this.providerFoodId;
        data["servingId"] = this.servingId ? this.servingId.toJSON() : <any>undefined;
        data["editedQuantity"] = this.editedQuantity;
        data["componentId"] = this.componentId;
        data["scaledQuantity"] = this.scaledQuantity;
        return data;
    }
}

export interface IUserSelectedServing {
    originalText?: string | undefined;
    provider?: string | undefined;
    providerFoodId?: string | undefined;
    servingId?: ServingIdentifier;
    editedQuantity?: number | undefined;
    componentId?: string | undefined;
    scaledQuantity?: number | undefined;
}

export class ValidateHandoffRequest implements IValidateHandoffRequest {
    nonce?: string | undefined;
    issuedAt?: number;
    redirectPath?: string | undefined;

    constructor(data?: IValidateHandoffRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nonce = _data["nonce"];
            this.issuedAt = _data["issuedAt"];
            this.redirectPath = _data["redirectPath"];
        }
    }

    static fromJS(data: any): ValidateHandoffRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateHandoffRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nonce"] = this.nonce;
        data["issuedAt"] = this.issuedAt;
        data["redirectPath"] = this.redirectPath;
        return data;
    }
}

export interface IValidateHandoffRequest {
    nonce?: string | undefined;
    issuedAt?: number;
    redirectPath?: string | undefined;
}

export class ValidateHandoffResponse implements IValidateHandoffResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    isValid?: boolean;
    errorCode?: string | undefined;
    redirectPath?: string | undefined;

    constructor(data?: IValidateHandoffResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.correlationId = _data["correlationId"];
            this.stackTrace = _data["stackTrace"];
            this.accountId = _data["accountId"];
            this.isPartial = _data["isPartial"];
            this.processingStage = _data["processingStage"];
            this.messageId = _data["messageId"];
            this.foodId = _data["foodId"];
            this.mealSelectionIsPending = _data["mealSelectionIsPending"];
            this.mealName = _data["mealName"];
            this.isRestricted = _data["isRestricted"];
            this.restrictedAccessPhase = _data["restrictedAccessPhase"];
            this.restrictedAccessRedirectUrl = _data["restrictedAccessRedirectUrl"];
            this.requiresAppUpdate = _data["requiresAppUpdate"];
            this.minimumAppVersion = _data["minimumAppVersion"];
            this.updateMessage = _data["updateMessage"];
            this.isValid = _data["isValid"];
            this.errorCode = _data["errorCode"];
            this.redirectPath = _data["redirectPath"];
        }
    }

    static fromJS(data: any): ValidateHandoffResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateHandoffResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["correlationId"] = this.correlationId;
        data["stackTrace"] = this.stackTrace;
        data["accountId"] = this.accountId;
        data["isPartial"] = this.isPartial;
        data["processingStage"] = this.processingStage;
        data["messageId"] = this.messageId;
        data["foodId"] = this.foodId;
        data["mealSelectionIsPending"] = this.mealSelectionIsPending;
        data["mealName"] = this.mealName;
        data["isRestricted"] = this.isRestricted;
        data["restrictedAccessPhase"] = this.restrictedAccessPhase;
        data["restrictedAccessRedirectUrl"] = this.restrictedAccessRedirectUrl;
        data["requiresAppUpdate"] = this.requiresAppUpdate;
        data["minimumAppVersion"] = this.minimumAppVersion;
        data["updateMessage"] = this.updateMessage;
        data["isValid"] = this.isValid;
        data["errorCode"] = this.errorCode;
        data["redirectPath"] = this.redirectPath;
        return data;
    }
}

export interface IValidateHandoffResponse {
    errors?: ErrorDto[] | undefined;
    isSuccess?: boolean;
    correlationId?: string | undefined;
    stackTrace?: string | undefined;
    accountId?: string | undefined;
    isPartial?: boolean;
    processingStage?: string | undefined;
    messageId?: string | undefined;
    foodId?: string | undefined;
    mealSelectionIsPending?: boolean | undefined;
    mealName?: string | undefined;
    isRestricted?: boolean;
    restrictedAccessPhase?: string | undefined;
    restrictedAccessRedirectUrl?: string | undefined;
    requiresAppUpdate?: boolean;
    minimumAppVersion?: string | undefined;
    updateMessage?: string | undefined;
    isValid?: boolean;
    errorCode?: string | undefined;
    redirectPath?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}